(() => {
  "use strict";

  // ==========================================================================
  // 現在のURLからドメイン直下のディレクトリ名を取得
  // ==========================================================================
  const urlPathArray = window.location.pathname.split("/");
  const directoryName = urlPathArray[1]; // ドメイン直下のディレクトリは2番目の要素です
  const csvFile = "/" + directoryName + "/common/csv/products_list.csv";
  // const csvFile01 = "/" + directoryName + "/common/csv/schedule.csv";
  // console.log(directoryName);

  // ==========================================================================
  // CSV：指定された品番をCSVから取得・出力
  // ==========================================================================

  $(".js-csv-output").each(function () {
    const appElem = this;
    const app = new Vue({
      el: appElem,
      data() {
        return {
          post: "", // JSON
          productionSchedule01: "", // 今月生産予定
          productionSchedule02: "", // 来月生産予定
          productionSchedule03: "", // 来月以降生産予定
          loading: true,
        };
      },
      methods: {
        getPosts() {
          // CSV読み込み
          $.ajax({
            dataType: "text", //text,json,jsonp,xml,html,script
            url: csvFile, //読み込むファイル指定
            cache: false,
            // Shift-JIS変換
            beforeSend: function (xhr) {
              xhr.overrideMimeType("text/html;charset=Shift-JIS"); //SJIS、Shift-JISいずれでも可能だった。
            },
          })
            .done((csvData) => {
              // 半角英数字、全角カタカナ変換
              let conv_hankaku = convertToHalfWidth(csvData);
              let conv_katakana = convertToFullWidthKatakana(conv_hankaku);

              // CSVの一行目JSON化
              const first_row = conv_katakana.slice(0, conv_katakana.indexOf("\n"));
              const first_row_array = first_row.split(",");
              this.productionSchedule01 = first_row_array[7]; // 今月生産予定
              this.productionSchedule02 = first_row_array[8]; // 来月生産予定
              this.productionSchedule03 = first_row_array[9]; // 来月以降生産予定

              // 成功
              // CSVTOJSON
              csv({
                output: "json",
              })
                .fromString(conv_katakana)
                .then((json) => {
                  // 指定した列の文字列をカンマ区切りで分割し、配列化する
                  json.forEach((item) => {
                    item["N/HO"] = item["N/HO"].split(",").map((value) => value.trim());
                  });

                  // フィルターにかけたい品番取得
                  const get_hinban = appElem.dataset.hinban;

                  // カンマ区切りで配列化
                  const get_hinban_array = get_hinban.split(",");

                  // フィルターしたデータ格納
                  let filter_array = [];

                  // 品番空欄除外
                  json = json.filter((item) => item["品番"] !== "");

                  // フィルター
                  for (let i = 0; i < get_hinban_array.length; i++) {
                    json.filter(function (item) {
                      if (item.品番 === get_hinban_array[i]) {
                        filter_array.push(item);
                      }
                    });
                  }

                  // ソート
                  // filter_array.sort(customDateSort);

                  // データ格納
                  const get_type = appElem.dataset.type;
                  if (get_type === "new_product") {
                    // 新製品
                    this.post = filter_array;
                  } else if (get_type === "announce") {
                    // 製品化決定
                    this.post = filter_array;
                  } else if (get_type === "detail") {
                    // 製品詳細
                    this.post = filter_array;
                  }

                  this.loading = false;
                });
            })
            .fail(() => {
              // 失敗
              this.loading = true;
            })
            .always(() => {
              // fail を含め処理が完了したときに起動
            });
        },
        formatDate(dateString) {
          if (dateString === "" || dateString === "未定") {
            return "未定";
          } else {
            // FireFoxバグ対応
            if (dateString.split("/").length === 2) {
              dateString = dateString + "/1";
            }

            // データフォーマットに変換
            const dateObject = new Date(dateString);

            // 年月を取得
            const year = dateObject.getFullYear();
            const month = dateObject.getMonth() + 1;
            // 年月で出力
            return year + "年" + month + "月発売";
          }
        },
        generatePermalink(flag, hinban) {
          // N/HOの配列内の文字列条件
          let safeflag = "";
          if (flag.includes("N") && flag.includes("HO")) {
            safeflag = "n";
          } else if (flag.includes("N")) {
            safeflag = "n";
          } else if (flag.includes("HO")) {
            safeflag = "ho";
          } else {
            safeflag = "n";
          }
          // URL生成
          const safehinban = encodeURIComponent(hinban);
          return "/" + directoryName + "/products/" + safeflag + "/" + safehinban + ".html";
        },
        generateImg(hinban, irregular = "_s") {
          // IMG生成
          const safehinban = encodeURIComponent(hinban);
          return "/" + directoryName + "/products/img/" + safehinban + irregular + ".jpg";
        },
        generatePdf(pdf) {
          // PDF生成
          const safepdf = encodeURIComponent(pdf);
          return "/" + directoryName + "/products/img/" + safepdf + ".pdf";
        },
      },
      created() {
        this.getPosts();
      },
      updated() {
        // DOM ツリーを更新した後に呼び出し
        const swiperProductsDetails = new Swiper("#js-swiper-products-details", {
          slidesPerView: "auto",
          freeMode: {
            enabled: true,
            momentumRatio: 0.3,
            momentumVelocityRatio: 0.35,
          },
          pagination: {
            el: ".swiper-pagination",
          },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          scrollbar: {
            el: ".swiper-scrollbar",
            hide: false,
            draggable: true,
          },
        });

        const setWindowEvents = ({ resize, scroll, load } = {}) => {
          window.addEventListener("resize", () => {
            window.requestAnimationFrame(() => {
              if (resize) {
                resize();
              }
              if (scroll) {
                scroll();
              }
            });
          });

          window.addEventListener("scroll", () => {
            window.requestAnimationFrame(() => {
              if (scroll) {
                scroll();
              }
            });
          });

          window.addEventListener("load", () => {
            if (resize) {
              resize();
            }
            if (scroll) {
              scroll();
            }
            if (load) {
              load();
            }
          });

          if (resize) {
            resize();
          }
          if (scroll) {
            scroll();
          }
        };

        if ($("#js-swiper-products-details")[0] || $("#js-swiper-new-product-information")[0] || $("#js-swiper-productization-decision")[0]) {
          $(".swiper").each(function () {
            if ($(this).attr("id") == "js-swiper-products-details" || $(this).attr("id") == "js-swiper-new-product-information" || $(this).attr("id") == "js-swiper-productization-decision") {
              const $swiper = $(this);
              let pageWidth = $swiper.outerWidth();
              const $slide = $swiper.find(".p-products-table-thumbnail-card");
              const slideMax = $slide.length;
              let slideWidth = $slide.outerWidth();
              let slidepr = parseInt($swiper.find(".p-products-table-thumbnail__item").css("padding-right"));
              let slidesWidth = slideWidth * slideMax + slidepr * (slideMax - 1);
              const $slidePrev = $swiper.find(".p-products-table-thumbnail__prev");
              const $slideNext = $swiper.find(".p-products-table-thumbnail__next");
              const $slideScrollbar = $swiper.find(".p-products-table-thumbnail__scrollbar");

              if (pageWidth > slidesWidth) {
                $slidePrev.css({ visibility: "hidden" });
                $slideNext.css({ visibility: "hidden" });
                $slideScrollbar.css({ visibility: "hidden" });
              }

              let slideWidthRight = 0;

              if ($swiper.attr("id") == "js-swiper-products-details" && slideMax > 4) {
                slideWidthRight = $(document).width() - $swiper.offset().left;

                if (slideWidthRight > slidesWidth) {
                  $slidePrev.css({ visibility: "hidden" });
                  $slideNext.css({ visibility: "hidden" });
                  $slideScrollbar.css({ visibility: "hidden" });
                  $swiper.children(".swiper-wrapper").addClass("-lock");
                }
              }

              if (($swiper.attr("id") == "js-swiper-new-product-information" || $swiper.attr("id") == "js-swiper-productization-decision") && slideMax > 3) {
                slideWidthRight = $(document).width() - $swiper.offset().left;

                if (slideWidthRight > slidesWidth) {
                  $slidePrev.css({ visibility: "hidden" });
                  $slideNext.css({ visibility: "hidden" });
                  $slideScrollbar.css({ visibility: "hidden" });
                }
              }

              let lastWidth = window.innerWidth;
              let timeoutID = 0;
              const delay = 200;

              const onResize = () => {
                clearTimeout(timeoutID);
                if (lastWidth != window.innerWidth) {
                  timeoutID = setTimeout(function () {
                    pageWidth = $swiper.outerWidth();
                    slideWidth = $slide.outerWidth();
                    slidepr = parseInt($(".p-products-table-thumbnail__item").css("padding-right"));
                    slidesWidth = slideWidth * slideMax + slidepr * (slideMax - 1);

                    if (pageWidth > slidesWidth) {
                      $slidePrev.css({ visibility: "hidden" });
                      $slideNext.css({ visibility: "hidden" });
                      $slideScrollbar.css({ visibility: "hidden" });
                    } else {
                      $slidePrev.css({ visibility: "" });
                      $slideNext.css({ visibility: "" });
                      $slideScrollbar.css({ visibility: "" });
                      $slideScrollbar.children().css({ transform: "translate3d(0, 0px, 0px)" });
                      $swiper.children(".swiper-wrapper").css({ transform: "translate3d(0, 0px, 0px)" });
                      $swiper.children(".swiper-wrapper").removeClass("-lock");
                    }

                    if ($swiper.attr("id") == "js-swiper-products-details" && slideMax > 4) {
                      slideWidthRight = $(document).width() - $swiper.offset().left;

                      if (slideWidthRight > slidesWidth) {
                        $slidePrev.css({ visibility: "hidden" });
                        $slideNext.css({ visibility: "hidden" });
                        $slideScrollbar.css({ visibility: "hidden" });
                        $swiper.children(".swiper-wrapper").addClass("-lock");
                      }
                    }

                    if (($swiper.attr("id") == "js-swiper-new-product-information" || $swiper.attr("id") == "js-swiper-productization-decision") && slideMax > 3) {
                      slideWidthRight = $(document).width() - $swiper.offset().left;

                      if (slideWidthRight > slidesWidth) {
                        $slidePrev.css({ visibility: "hidden" });
                        $slideNext.css({ visibility: "hidden" });
                        $slideScrollbar.css({ visibility: "hidden" });
                        $swiper.children(".swiper-wrapper").addClass("-lock");
                      }
                    }
                  }, delay);
                  lastWidth = window.innerWidth;
                }
              };

              setWindowEvents({
                resize: onResize,
                scroll: null,
                load: null,
              });
            }
          });
        }

        lazyload();
      },
    });
  });

  // ==========================================================================
  // CSV：品番も元にCSVからJANコード取得・出力
  // ==========================================================================

  $(".js-csv-output-jancode").each(function () {
    const appElem = this;
    const app = new Vue({
      el: appElem,
      data() {
        return {
          jancode: "", // JSON
        };
      },
      methods: {
        getPosts() {
          // CSV読み込み
          $.ajax({
            dataType: "text", //text,json,jsonp,xml,html,script
            url: csvFile, //読み込むファイル指定
            cache: false,
            // Shift-JIS変換
            beforeSend: function (xhr) {
              xhr.overrideMimeType("text/html;charset=Shift-JIS"); //SJIS、Shift-JISいずれでも可能だった。
            },
          })
            .done((csvData) => {
              // 半角英数字、全角カタカナ変換
              let conv_hankaku = convertToHalfWidth(csvData);
              let conv_katakana = convertToFullWidthKatakana(conv_hankaku);

              // 成功
              // CSVTOJSON
              csv({
                output: "json",
              })
                .fromString(conv_katakana)
                .then((json) => {
                  // フィルターにかけたい品番取得
                  const get_hinban = appElem.dataset.hinban;

                  // // フィルター
                  json = json.filter((item) => item["品番"] === get_hinban);

                  // データ格納
                  if (json.length === 0) {
                    this.jancode = "-";
                  } else {
                    this.jancode = json[0]["JANコード"];
                  }
                });
            })
            .fail(() => {
              // 失敗
            })
            .always(() => {
              // fail を含め処理が完了したときに起動
            });
        },
      },
      created() {
        this.getPosts();
      },
    });
  });

  // ==========================================================================
  // 製品詳細 | 旧関連製品
  // ==========================================================================

  const existingRelatedProduct = document.querySelector(".js-existing-related-product");

  if (existingRelatedProduct) {
    const sourceCode = existingRelatedProduct.innerHTML;
    const parser = new DOMParser();
    const doc = parser.parseFromString(sourceCode, "text/html");
    const liElements = doc.querySelectorAll("li");
    liElements.forEach(function (liElement) {
      const aElement = liElement.querySelector("a");
      const imgElement = aElement.querySelector("img");
      const textNode = aElement.childNodes[2];

      const newLiElement = document.createElement("div");
      newLiElement.classList.add("swiper-slide", "p-products-table-thumbnail__item");

      const newAElement = document.createElement("a");
      newAElement.classList.add("c-text-link", "u-text-decoration-none", "p-products-table-thumbnail-card");
      newAElement.setAttribute("href", aElement.getAttribute("href"));

      const newImgDiv = document.createElement("div");
      newImgDiv.classList.add("p-products-table-thumbnail-card__image");

      const newImgElement = document.createElement("img");
      newImgElement.classList.add("p-products-table-thumbnail-card__image-item", "lazyload");
      newImgElement.setAttribute("src", "/" + directoryName + "/common/img/placeholder.gif");
      newImgElement.setAttribute("data-src", imgElement.getAttribute("src"));
      newImgElement.setAttribute("src", imgElement.getAttribute("src"));
      newImgElement.setAttribute("alt", imgElement.getAttribute("alt"));
      newImgElement.setAttribute("width", "262");
      newImgElement.setAttribute("height", "197");

      const newTextDiv = document.createElement("div");
      newTextDiv.classList.add("p-products-table-thumbnail-card__text");

      const newH3Element = document.createElement("h3");
      newH3Element.classList.add("p-products-table-thumbnail-card__title");
      newH3Element.textContent = textNode.textContent;

      newAElement.appendChild(newImgDiv);
      newImgDiv.appendChild(newImgElement);
      newAElement.appendChild(newTextDiv);
      newTextDiv.appendChild(newH3Element);
      newLiElement.appendChild(newAElement);
      document.getElementById("js-related-product").appendChild(newLiElement);
    });
    existingRelatedProduct.remove();

    // const existingRelatedProductSwiper = new Swiper(".js-swiper-old-related-product", {
    //   slidesPerView: "auto",
    //   freeMode: {
    //     enabled: true,
    //     momentumRatio: 0.3,
    //     momentumVelocityRatio: 0.35,
    //   },
    //   pagination: {
    //     el: ".swiper-pagination",
    //   },
    //   navigation: {
    //     nextEl: ".swiper-button-next",
    //     prevEl: ".swiper-button-prev",
    //   },
    //   scrollbar: {
    //     el: ".swiper-scrollbar",
    //     hide: false,
    //     draggable: true,
    //   },
    // });
  }

  // ==========================================================================
  // CSV：発売スケジュール
  // ==========================================================================

  $(".js-csv-schedule").each(function () {
    // リスト更新日取得
    const getType = $(this).data("type");
    const listUpdateDate = $("#js-schedule-date").data("update");
    // 今年の残り月数取得
    const currentDate = new Date(listUpdateDate);
    const currentYear = currentDate.getFullYear(); // 現在の年を取得
    const currentMonth = currentDate.getMonth() + 1; // 現在の月を取得 (0から始まるため、1を足す)
    const remainingMonths = []; // 残りの月数を計算 (12から現在の月を引く)
    const appElem = this;

    const app = new Vue({
      el: appElem,
      data() {
        return {
          loading: true,
          displayNotFlag: false, // 条件なしフラグ
          dataCurrentYear: currentYear, // 現在の年
          dataNextYear: currentYear + 1, // 現在の来年
          datalastYear: currentYear - 1, // 現在の昨年
          dataRemainingMonths: [], //残りの月数
          dataForNextYear: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12], //来年分の月数
          dataForLastYear: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12], //去年分の月数
          // datePastYear: [], // 現在年～2015
          // datePastYearOutput: currentYear,
          // post: "", // 出力用JSON
          // postJson: "", // フィルター用JSON
          post01: "", // 01月の出力用JSON
          post01Json: "", // 01月のフィルター用JSON
          post02: "", // 02月の出力用JSON
          post02Json: "", // 02月のフィルター用JSON
          post03: "", // 03月の出力用JSON
          post03Json: "", // 03月のフィルター用JSON
          post04: "", // 04月の出力用JSON
          post04Json: "", // 04月のフィルター用JSON
          post05: "", // 05月の出力用JSON
          post05Json: "", // 05月のフィルター用JSON
          post06: "", // 06月の出力用JSON
          post06Json: "", // 06月のフィルター用JSON
          post07: "", // 07月の出力用JSON
          post07Json: "", // 07月のフィルター用JSON
          post08: "", // 08月の出力用JSON
          post08Json: "", // 08月のフィルター用JSON
          post09: "", // 09月の出力用JSON
          post09Json: "", // 09月のフィルター用JSON
          post10: "", // 10月の出力用JSON
          post10Json: "", // 10月のフィルター用JSON
          post11: "", // 11月の出力用JSON
          post11Json: "", // 11月のフィルター用JSON
          post12: "", // 12月の出力用JSON
          post12Json: "", // 12月のフィルター用JSON
          postNextYear01: "", // 来年1月の出力用JSON
          postNextYear01Json: "", // 来年1月のフィルター用JSON
          postNextYear02: "", // 来年2月の出力用JSON
          postNextYear02Json: "", // 来年2月のフィルター用JSON
          postNextYear03: "", // 来年3月の出力用JSON
          postNextYear03Json: "", // 来年3月のフィルター用JSON
          postNextYear04: "", // 来年4月の出力用JSON
          postNextYear04Json: "", // 来年4月のフィルター用JSON
          postNextYear05: "", // 来年5月の出力用JSON
          postNextYear05Json: "", // 来年5月のフィルター用JSON
          postNextYear06: "", // 来年6月の出力用JSON
          postNextYear06Json: "", // 来年6月のフィルター用JSON
          postNextYear07: "", // 来年7月の出力用JSON
          postNextYear07Json: "", // 来年7月のフィルター用JSON
          postNextYear08: "", // 来年8月の出力用JSON
          postNextYear08Json: "", // 来年8月のフィルター用JSON
          postNextYear09: "", // 来年9月の出力用JSON
          postNextYear09Json: "", // 来年9月のフィルター用JSON
          postNextYear10: "", // 来年10月の出力用JSON
          postNextYear10Json: "", // 来年10月のフィルター用JSON
          postNextYear11: "", // 来年11月の出力用JSON
          postNextYear11Json: "", // 来年11月のフィルター用JSON
          postNextYear12: "", // 来年12月の出力用JSON
          postNextYear12Json: "", // 来年12月のフィルター用JSON
          postFutureRelease: "", // 発売予定品
          postFutureReleaseJson: "", // 発売予定品用JSON
          filterStatus: "", //フィルター用 ステータス
          filterNHO: "", //フィルター用 N/HO
          filterParentCategory: "", //フィルター用 大カテゴリ
          datefilterParentCategory: [
            { id: 1, label: "車両", value: "cat-carset,ho-cat-carset" },
            { id: 2, label: "制御機器", value: "cat-cont" },
            { id: 3, label: "レール", value: "cat-rail" },
            { id: 4, label: "建物", value: "cat-struct" },
            { id: 5, label: "その他", value: "cat-etc,ho-cat-etc" },
            // { id: 6, label: "オプショナルパーツ", value: "cat-oparts,ho-cat-oparts" },
            // { id: 7, label: "分売パーツ", value: "cat-parts,ho-cat-parts" },
          ], //大カテゴリー絞り込みのデータ
          filterCategoryCar: [
            { id: 1, label: "蒸気機関車", value: "sloc" },
            { id: 2, label: "電気機関車", value: "eloc,ho-eloc" },
            { id: 3, label: "ディーゼル機関車", value: "dloc,ho-dloc" },
            { id: 4, label: "新幹線", value: "sin" },
            { id: 5, label: "電車", value: "ele,ho-ele" },
            { id: 6, label: "ディーゼルカー・ハイブリット車", value: "di,ho-di" },
            { id: 7, label: "客車", value: "kya,ho-kya" },
            { id: 8, label: "貨車", value: "wag,ho-wag" },
            { id: 9, label: "私鉄・第三セクター", value: "pri,ho-pri" },
            { id: 10, label: "試験車", value: "train" },
            { id: 11, label: "スーパーセレクトセット", value: "spset" },
            { id: 12, label: "ファーストカーミュージアム", value: "fcm" },
            { id: 13, label: "トーマスシリーズ", value: "thomas" },
          ], //車両絞り込みのデータ
          selectedCategoryCar: [], //フィルター用 車両絞り込み
          disabledCategoryCar: false, // 車両の無効化
          // nOnlyCategoryCar: ["ho_test"], // HOにはない・Nのみの車両のデータ
          isCheckedCategoryCar: true, //車両絞り込みのチェック判別
          filterDecision: "", //フィルター用 発売日決定
          isCheckedDecision: false, //発売日決定のチェック判別
          filterUpdate: "", //フィルター用 更新日
          isCheckedUpdate: false, //更新日のチェック判別
          isDateBeforeToday: false,
        };
      },
      methods: {
        remainingMonths() {
          // 残り月数・過ぎた月数
          if (getType !== "past") {
            // 今月以降
            for (let i = currentMonth; i <= 12; i++) {
              remainingMonths.push(i);
            }
          } else {
            // 先月以前
            for (let i = currentMonth - 1; i >= 1; i--) {
              remainingMonths.push(i);
            }
            remainingMonths.reverse();
          }
          this.dataRemainingMonths = remainingMonths; // 残りの月数をデータ化
        },
        getPosts() {
          // const testhttest = this.dataRemainingMonths;
          // const get_year = this.dataCurrentYear; //現在年取得

          // CSV読み込み
          $.ajax({
            dataType: "text", //text,json,jsonp,xml,html,script
            url: csvFile, //読み込むファイル指定
            cache: false,
            // success: function (data) {},
            // Shift-JIS変換
            beforeSend: function (xhr) {
              // xhr.overrideMimeType("text/html;charset=SJIS");
              xhr.overrideMimeType("text/html;charset=Shift-JIS"); //SJIS、Shift-JISいずれでも可能だった。
            },
          })
            .done((csvData) => {
              // 半角英数字、全角カタカナ変換
              let conv_hankaku = convertToHalfWidth(csvData);
              let conv_katakana = convertToFullWidthKatakana(conv_hankaku);

              // CSVデータ
              // console.log("CSVデータ", conv_katakana);

              // CSVの一行目JSON化
              // const first_row = conv_katakana.slice(0, conv_katakana.indexOf("\n"));
              // const first_row_array = first_row.split(",");
              // // console.log("CSVの一行目JSON化", first_row_array);

              // 成功
              // CSVTOJSON
              csv({
                output: "json",
              })
                .fromString(conv_katakana)
                .then((json) => {
                  // // 最新の年をCSVから取得
                  // var maxYear = "";
                  // // JSONデータ内をループして最新の年を見つける
                  // json.forEach(function (item) {
                  //   if (item.発売月 > maxYear) {
                  //     maxYear = item.発売月;
                  //   }
                  // });
                  // console.log("最新の年: " + new Date(maxYear).getFullYear());

                  // 指定した列の文字列をカンマ区切りで分割し、配列化する
                  json.forEach((item) => {
                    item["N/HO"] = item["N/HO"].split(",").map((value) => value.trim());
                    item["大カテゴリ"] = item["大カテゴリ"].split(",").map((value) => value.trim());
                    item["小カテゴリ"] = item["小カテゴリ"].split(",").map((value) => value.trim());
                    item["備考"] = item["備考"].split(",").map((value) => value.trim());
                  });

                  // デフォルトフィルター
                  const defaultFilter = json.filter((item) => item["発売スケジュールに表示"] === "1");

                  // 今年
                  const dateFilter01 = this.filteredData(defaultFilter, this.dataCurrentYear, 1);
                  const dateFilter02 = this.filteredData(defaultFilter, this.dataCurrentYear, 2);
                  const dateFilter03 = this.filteredData(defaultFilter, this.dataCurrentYear, 3);
                  const dateFilter04 = this.filteredData(defaultFilter, this.dataCurrentYear, 4);
                  const dateFilter05 = this.filteredData(defaultFilter, this.dataCurrentYear, 5);
                  const dateFilter06 = this.filteredData(defaultFilter, this.dataCurrentYear, 6);
                  const dateFilter07 = this.filteredData(defaultFilter, this.dataCurrentYear, 7);
                  const dateFilter08 = this.filteredData(defaultFilter, this.dataCurrentYear, 8);
                  const dateFilter09 = this.filteredData(defaultFilter, this.dataCurrentYear, 9);
                  const dateFilter10 = this.filteredData(defaultFilter, this.dataCurrentYear, 10);
                  const dateFilter11 = this.filteredData(defaultFilter, this.dataCurrentYear, 11);
                  const dateFilter12 = this.filteredData(defaultFilter, this.dataCurrentYear, 12);

                  let dataPastFutureYear = "";
                  if (getType !== "past") {
                    // 来年
                    dataPastFutureYear = this.dataNextYear;
                  } else {
                    // 昨年
                    dataPastFutureYear = this.datalastYear;
                  }

                  const dateFilterNextYear01 = this.filteredData(defaultFilter, dataPastFutureYear, 1);
                  const dateFilterNextYear02 = this.filteredData(defaultFilter, dataPastFutureYear, 2);
                  const dateFilterNextYear03 = this.filteredData(defaultFilter, dataPastFutureYear, 3);
                  const dateFilterNextYear04 = this.filteredData(defaultFilter, dataPastFutureYear, 4);
                  const dateFilterNextYear05 = this.filteredData(defaultFilter, dataPastFutureYear, 5);
                  const dateFilterNextYear06 = this.filteredData(defaultFilter, dataPastFutureYear, 6);
                  const dateFilterNextYear07 = this.filteredData(defaultFilter, dataPastFutureYear, 7);
                  const dateFilterNextYear08 = this.filteredData(defaultFilter, dataPastFutureYear, 8);
                  const dateFilterNextYear09 = this.filteredData(defaultFilter, dataPastFutureYear, 9);
                  const dateFilterNextYear10 = this.filteredData(defaultFilter, dataPastFutureYear, 10);
                  const dateFilterNextYear11 = this.filteredData(defaultFilter, dataPastFutureYear, 11);
                  const dateFilterNextYear12 = this.filteredData(defaultFilter, dataPastFutureYear, 12);

                  // 発売予定品
                  // const filterFutureRelease = defaultFilter.filter((item) => item["発売予定"] === "1");

                  // this.post = this.sortData(defaultFilter);

                  // this.postJson = this.post;

                  // 今年のデータ
                  this.post01 = dateFilter01.sort(customDateSortReverse);
                  this.post01Json = this.post01;
                  this.post02 = dateFilter02.sort(customDateSortReverse);
                  this.post02Json = this.post02;
                  this.post03 = dateFilter03.sort(customDateSortReverse);
                  this.post03Json = this.post03;
                  this.post04 = dateFilter04.sort(customDateSortReverse);
                  this.post04Json = this.post04;
                  this.post05 = dateFilter05.sort(customDateSortReverse);
                  this.post05Json = this.post05;
                  this.post06 = dateFilter06.sort(customDateSortReverse);
                  this.post06Json = this.post06;
                  this.post07 = dateFilter07.sort(customDateSortReverse);
                  this.post07Json = this.post07;
                  this.post08 = dateFilter08.sort(customDateSortReverse);
                  this.post08Json = this.post08;
                  this.post09 = dateFilter09.sort(customDateSortReverse);
                  this.post09Json = this.post09;
                  this.post10 = dateFilter10.sort(customDateSortReverse);
                  this.post10Json = this.post10;
                  this.post11 = dateFilter11.sort(customDateSortReverse);
                  this.post11Json = this.post11;
                  this.post12 = dateFilter12.sort(customDateSortReverse);
                  this.post12Json = this.post12;

                  // 来年のデータ
                  this.postNextYear01 = dateFilterNextYear01.sort(customDateSortReverse);
                  this.postNextYear01Json = this.postNextYear01;
                  this.postNextYear02 = dateFilterNextYear02.sort(customDateSortReverse);
                  this.postNextYear02Json = this.postNextYear02;
                  this.postNextYear03 = dateFilterNextYear03.sort(customDateSortReverse);
                  this.postNextYear03Json = this.postNextYear03;
                  this.postNextYear04 = dateFilterNextYear04.sort(customDateSortReverse);
                  this.postNextYear04Json = this.postNextYear04;
                  this.postNextYear05 = dateFilterNextYear05.sort(customDateSortReverse);
                  this.postNextYear05Json = this.postNextYear05;
                  this.postNextYear06 = dateFilterNextYear06.sort(customDateSortReverse);
                  this.postNextYear06Json = this.postNextYear06;
                  this.postNextYear07 = dateFilterNextYear07.sort(customDateSortReverse);
                  this.postNextYear07Json = this.postNextYear07;
                  this.postNextYear08 = dateFilterNextYear08.sort(customDateSortReverse);
                  this.postNextYear08Json = this.postNextYear08;
                  this.postNextYear09 = dateFilterNextYear09.sort(customDateSortReverse);
                  this.postNextYear09Json = this.postNextYear09;
                  this.postNextYear10 = dateFilterNextYear10.sort(customDateSortReverse);
                  this.postNextYear10Json = this.postNextYear10;
                  this.postNextYear11 = dateFilterNextYear11.sort(customDateSortReverse);
                  this.postNextYear11Json = this.postNextYear11;
                  this.postNextYear12 = dateFilterNextYear12.sort(customDateSortReverse);
                  this.postNextYear12Json = this.postNextYear12;

                  // 発売予定品
                  const filterFutureRelease = json.filter((item) => item["発売月"] === "未定");

                  // 発売予定品
                  this.postFutureRelease = filterFutureRelease;
                  this.postFutureReleaseJson = this.postFutureRelease;

                  // ローディング終了
                  this.loading = false;
                  // console.log("END");
                });
            })
            .fail(() => {
              // 失敗
            })
            .always(() => {
              // fail を含め処理が完了したときに起動
            });
        },
        filteredData(json, year, month) {
          return json.filter((item) => {
            // JSON内の日付をDateオブジェクトに変換
            let itemDate = "";
            if (item["ステータス"] === "再生産") {
              // itemDate = new Date(item["再生産日"]);
              itemDate = item["再生産日"];
            } else {
              // itemDate = new Date(item["発売月"]);
              itemDate = item["発売月"];
            }

            // ゼロパディング
            let retMonth = ("00" + month).slice(-2);

            return (
              // itemDate.getFullYear() === year && itemDate.getMonth() === month - 1 // JavaScriptの月は0から始まるため、1を引く
              itemDate.startsWith(year + "/" + retMonth)
            );
          });
        },
        clickFilterStatus(value) {
          // ステータス
          // フィルター開始
          this.setFilter(value, this.filterNHO, this.filterParentCategory, this.filterCategoryCar, this.isCheckedDecision, this.isCheckedUpdate);
        },
        clickFilterNHO(value) {
          // フィルター開始
          this.setFilter(this.filterStatus, value, this.filterParentCategory, this.filterCategoryCar, this.isCheckedDecision, this.isCheckedUpdate);
        },
        clickFilterParentCategory(value) {
          // 大カテゴリ
          // すべてと車両以外にチャックがあるとき
          if (!(value === "" || value === "cat-carset,ho-cat-carset")) {
            this.selectedCategoryCar = []; // 車両絞込すべてに変更
            this.disabledCategoryCar = true; // 車両絞込無効化
          } else {
            this.disabledCategoryCar = false; // 車両絞込有効化
          }

          // フィルター開始
          this.setFilter(this.filterStatus, this.filterNHO, value, this.filterCategoryCar, this.isCheckedDecision, this.isCheckedUpdate);
        },
        clickCategoryCar(value) {
          // 処理前にすべてチェック&値が空&大カテゴリーがすべての場合
          if (value === "" && this.filterParentCategory == "") {
          } else {
            // それ以外 ・ 大カテゴリー「車両」を選択
            this.filterParentCategory = "cat-carset,ho-cat-carset";
          }

          // 小カテゴリ すべてがtrueの場合、他チェック解除
          if (value === "") {
            this.selectedCategoryCar = [];
          }

          this.setFilter(this.filterStatus, this.filterNHO, this.filterParentCategory, this.filterCategoryCar, this.isCheckedDecision, this.isCheckedUpdate);
        },
        clickFilterDecision(value) {
          // 発売日決定
          // フィルター開始
          this.setFilter(this.filterStatus, this.filterNHO, this.filterParentCategory, this.filterCategoryCar, this.isCheckedDecision, this.isCheckedUpdate);
        },
        clickFilterUpdate(value) {
          // 更新日
          // フィルター開始
          this.setFilter(this.filterStatus, this.filterNHO, this.filterParentCategory, this.filterCategoryCar, this.isCheckedDecision, this.isCheckedUpdate);
        },
        setFilter(status, nho, parentCategory, categoryCar, decision, update) {
          // 引数
          // ステータス, N/HO, 大カテゴリ, 車両絞り込み, 発売日決定, 更新日
          // (filterStatus, filterNHO, filterParentCategory, filterCategoryCar, filterDecision, filterUpdate)

          // ローディング開始
          this.loading = true;
          // let filtered = this.postJson; // 恒久JSON
          //
          let filtered01 = this.post01Json;
          let filtered02 = this.post02Json;
          let filtered03 = this.post03Json;
          let filtered04 = this.post04Json;
          let filtered05 = this.post05Json;
          let filtered06 = this.post06Json;
          let filtered07 = this.post07Json;
          let filtered08 = this.post08Json;
          let filtered09 = this.post09Json;
          let filtered10 = this.post10Json;
          let filtered11 = this.post11Json;
          let filtered12 = this.post12Json;
          //
          let filteredNextYear01 = this.postNextYear01Json;
          let filteredNextYear02 = this.postNextYear02Json;
          let filteredNextYear03 = this.postNextYear03Json;
          let filteredNextYear04 = this.postNextYear04Json;
          let filteredNextYear05 = this.postNextYear05Json;
          let filteredNextYear06 = this.postNextYear06Json;
          let filteredNextYear07 = this.postNextYear07Json;
          let filteredNextYear08 = this.postNextYear08Json;
          let filteredNextYear09 = this.postNextYear09Json;
          let filteredNextYear10 = this.postNextYear10Json;
          let filteredNextYear11 = this.postNextYear11Json;
          let filteredNextYear12 = this.postNextYear12Json;

          //
          let filteredFutureRelease = this.postFutureReleaseJson;

          // データ更新
          this.filterStatus = status; // ステータス
          this.filterNHO = nho; // N/HO
          this.filterParentCategory = parentCategory; // 大カテゴリ
          this.filterCategoryCar = categoryCar; // 車両絞り込み

          // if (this.isCheckedDecision) {
          //   this.filterDecision = "1"; // 発売日決定
          // } else {
          //   this.filterDecision = ""; // 発売日決定
          // }
          this.filterUpdate = update; // 更新日

          // 変数化
          let valueStatus = this.filterStatus; // ステータス
          let valueNHO = this.filterNHO; // N/HO
          let valueParentCategory = this.filterParentCategory; // 大カテゴリ
          let valueCategoryCar = this.filterCategoryCar; // 車両絞り込み
          // let valueDecision = this.filterDecision; // 発売日決定
          let valueUpdate = this.filterUpdate; // 更新日

          // フィルター ステータス
          if (valueStatus) {
            // filtered = filtered.filter((item) => item["ステータス"] === valueStatus);
            //
            filtered01 = filtered01.filter((item) => item["ステータス"] === valueStatus);
            filtered02 = filtered02.filter((item) => item["ステータス"] === valueStatus);
            filtered03 = filtered03.filter((item) => item["ステータス"] === valueStatus);
            filtered04 = filtered04.filter((item) => item["ステータス"] === valueStatus);
            filtered05 = filtered05.filter((item) => item["ステータス"] === valueStatus);
            filtered06 = filtered06.filter((item) => item["ステータス"] === valueStatus);
            filtered07 = filtered07.filter((item) => item["ステータス"] === valueStatus);
            filtered08 = filtered08.filter((item) => item["ステータス"] === valueStatus);
            filtered09 = filtered09.filter((item) => item["ステータス"] === valueStatus);
            filtered10 = filtered10.filter((item) => item["ステータス"] === valueStatus);
            filtered11 = filtered11.filter((item) => item["ステータス"] === valueStatus);
            filtered12 = filtered12.filter((item) => item["ステータス"] === valueStatus);
            //
            filteredNextYear01 = filteredNextYear01.filter((item) => item["ステータス"] === valueStatus);
            filteredNextYear02 = filteredNextYear02.filter((item) => item["ステータス"] === valueStatus);
            filteredNextYear03 = filteredNextYear03.filter((item) => item["ステータス"] === valueStatus);
            filteredNextYear04 = filteredNextYear04.filter((item) => item["ステータス"] === valueStatus);
            filteredNextYear05 = filteredNextYear05.filter((item) => item["ステータス"] === valueStatus);
            filteredNextYear06 = filteredNextYear06.filter((item) => item["ステータス"] === valueStatus);
            filteredNextYear07 = filteredNextYear07.filter((item) => item["ステータス"] === valueStatus);
            filteredNextYear08 = filteredNextYear08.filter((item) => item["ステータス"] === valueStatus);
            filteredNextYear09 = filteredNextYear09.filter((item) => item["ステータス"] === valueStatus);
            filteredNextYear10 = filteredNextYear10.filter((item) => item["ステータス"] === valueStatus);
            filteredNextYear11 = filteredNextYear11.filter((item) => item["ステータス"] === valueStatus);
            filteredNextYear12 = filteredNextYear12.filter((item) => item["ステータス"] === valueStatus);
            //
            filteredFutureRelease = filteredFutureRelease.filter((item) => item["ステータス"] === valueStatus);
          }

          // フィルター N/HO
          if (valueNHO) {
            // filtered = filtered.filter((item) => item["N/HO"].includes(valueNHO));
            //
            filtered01 = filtered01.filter((item) => item["N/HO"].includes(valueNHO));
            filtered02 = filtered02.filter((item) => item["N/HO"].includes(valueNHO));
            filtered03 = filtered03.filter((item) => item["N/HO"].includes(valueNHO));
            filtered04 = filtered04.filter((item) => item["N/HO"].includes(valueNHO));
            filtered05 = filtered05.filter((item) => item["N/HO"].includes(valueNHO));
            filtered06 = filtered06.filter((item) => item["N/HO"].includes(valueNHO));
            filtered07 = filtered07.filter((item) => item["N/HO"].includes(valueNHO));
            filtered08 = filtered08.filter((item) => item["N/HO"].includes(valueNHO));
            filtered09 = filtered09.filter((item) => item["N/HO"].includes(valueNHO));
            filtered10 = filtered10.filter((item) => item["N/HO"].includes(valueNHO));
            filtered11 = filtered11.filter((item) => item["N/HO"].includes(valueNHO));
            filtered12 = filtered12.filter((item) => item["N/HO"].includes(valueNHO));
            //
            filteredNextYear01 = filteredNextYear01.filter((item) => item["N/HO"].includes(valueNHO));
            filteredNextYear02 = filteredNextYear02.filter((item) => item["N/HO"].includes(valueNHO));
            filteredNextYear03 = filteredNextYear03.filter((item) => item["N/HO"].includes(valueNHO));
            filteredNextYear04 = filteredNextYear04.filter((item) => item["N/HO"].includes(valueNHO));
            filteredNextYear05 = filteredNextYear05.filter((item) => item["N/HO"].includes(valueNHO));
            filteredNextYear06 = filteredNextYear06.filter((item) => item["N/HO"].includes(valueNHO));
            filteredNextYear07 = filteredNextYear07.filter((item) => item["N/HO"].includes(valueNHO));
            filteredNextYear08 = filteredNextYear08.filter((item) => item["N/HO"].includes(valueNHO));
            filteredNextYear09 = filteredNextYear09.filter((item) => item["N/HO"].includes(valueNHO));
            filteredNextYear10 = filteredNextYear10.filter((item) => item["N/HO"].includes(valueNHO));
            filteredNextYear11 = filteredNextYear11.filter((item) => item["N/HO"].includes(valueNHO));
            filteredNextYear12 = filteredNextYear12.filter((item) => item["N/HO"].includes(valueNHO));
            //
            filteredFutureRelease = filteredFutureRelease.filter((item) => item["N/HO"].includes(valueNHO));
          }

          // フィルター 大カテゴリ
          if (valueParentCategory) {
            // カンマがある場合
            if (valueParentCategory.includes(",")) {
              // カンマで区切られた文字列を分割して配列に追加
              const parentCategoryArray = valueParentCategory.split(",");
              // フィルター
              // filtered = filtered.filter((item) => item["大カテゴリ"].includes(parentCategoryArray[0]) || item["大カテゴリ"].includes(parentCategoryArray[1]));
              //
              filtered01 = filtered01.filter((item) => item["大カテゴリ"].includes(parentCategoryArray[0]) || item["大カテゴリ"].includes(parentCategoryArray[1]));
              filtered02 = filtered02.filter((item) => item["大カテゴリ"].includes(parentCategoryArray[0]) || item["大カテゴリ"].includes(parentCategoryArray[1]));
              filtered03 = filtered03.filter((item) => item["大カテゴリ"].includes(parentCategoryArray[0]) || item["大カテゴリ"].includes(parentCategoryArray[1]));
              filtered04 = filtered04.filter((item) => item["大カテゴリ"].includes(parentCategoryArray[0]) || item["大カテゴリ"].includes(parentCategoryArray[1]));
              filtered05 = filtered05.filter((item) => item["大カテゴリ"].includes(parentCategoryArray[0]) || item["大カテゴリ"].includes(parentCategoryArray[1]));
              filtered06 = filtered06.filter((item) => item["大カテゴリ"].includes(parentCategoryArray[0]) || item["大カテゴリ"].includes(parentCategoryArray[1]));
              filtered07 = filtered07.filter((item) => item["大カテゴリ"].includes(parentCategoryArray[0]) || item["大カテゴリ"].includes(parentCategoryArray[1]));
              filtered08 = filtered08.filter((item) => item["大カテゴリ"].includes(parentCategoryArray[0]) || item["大カテゴリ"].includes(parentCategoryArray[1]));
              filtered09 = filtered09.filter((item) => item["大カテゴリ"].includes(parentCategoryArray[0]) || item["大カテゴリ"].includes(parentCategoryArray[1]));
              filtered10 = filtered10.filter((item) => item["大カテゴリ"].includes(parentCategoryArray[0]) || item["大カテゴリ"].includes(parentCategoryArray[1]));
              filtered11 = filtered11.filter((item) => item["大カテゴリ"].includes(parentCategoryArray[0]) || item["大カテゴリ"].includes(parentCategoryArray[1]));
              filtered12 = filtered12.filter((item) => item["大カテゴリ"].includes(parentCategoryArray[0]) || item["大カテゴリ"].includes(parentCategoryArray[1]));
              //
              filteredNextYear01 = filteredNextYear01.filter((item) => item["大カテゴリ"].includes(parentCategoryArray[0]) || item["大カテゴリ"].includes(parentCategoryArray[1]));
              filteredNextYear02 = filteredNextYear02.filter((item) => item["大カテゴリ"].includes(parentCategoryArray[0]) || item["大カテゴリ"].includes(parentCategoryArray[1]));
              filteredNextYear03 = filteredNextYear03.filter((item) => item["大カテゴリ"].includes(parentCategoryArray[0]) || item["大カテゴリ"].includes(parentCategoryArray[1]));
              filteredNextYear04 = filteredNextYear04.filter((item) => item["大カテゴリ"].includes(parentCategoryArray[0]) || item["大カテゴリ"].includes(parentCategoryArray[1]));
              filteredNextYear05 = filteredNextYear05.filter((item) => item["大カテゴリ"].includes(parentCategoryArray[0]) || item["大カテゴリ"].includes(parentCategoryArray[1]));
              filteredNextYear06 = filteredNextYear06.filter((item) => item["大カテゴリ"].includes(parentCategoryArray[0]) || item["大カテゴリ"].includes(parentCategoryArray[1]));
              filteredNextYear07 = filteredNextYear07.filter((item) => item["大カテゴリ"].includes(parentCategoryArray[0]) || item["大カテゴリ"].includes(parentCategoryArray[1]));
              filteredNextYear08 = filteredNextYear08.filter((item) => item["大カテゴリ"].includes(parentCategoryArray[0]) || item["大カテゴリ"].includes(parentCategoryArray[1]));
              filteredNextYear09 = filteredNextYear09.filter((item) => item["大カテゴリ"].includes(parentCategoryArray[0]) || item["大カテゴリ"].includes(parentCategoryArray[1]));
              filteredNextYear10 = filteredNextYear10.filter((item) => item["大カテゴリ"].includes(parentCategoryArray[0]) || item["大カテゴリ"].includes(parentCategoryArray[1]));
              filteredNextYear11 = filteredNextYear11.filter((item) => item["大カテゴリ"].includes(parentCategoryArray[0]) || item["大カテゴリ"].includes(parentCategoryArray[1]));
              filteredNextYear12 = filteredNextYear12.filter((item) => item["大カテゴリ"].includes(parentCategoryArray[0]) || item["大カテゴリ"].includes(parentCategoryArray[1]));
              //
              filteredFutureRelease = filteredFutureRelease.filter((item) => item["大カテゴリ"].includes(parentCategoryArray[0]) || item["大カテゴリ"].includes(parentCategoryArray[1]));
            } else {
              // カンマが含まれていない場合、そのままフィルター
              // filtered = filtered.filter((item) => item["大カテゴリ"].includes(valueParentCategory));
              //
              filtered01 = filtered01.filter((item) => item["大カテゴリ"].includes(valueParentCategory));
              filtered02 = filtered02.filter((item) => item["大カテゴリ"].includes(valueParentCategory));
              filtered03 = filtered03.filter((item) => item["大カテゴリ"].includes(valueParentCategory));
              filtered04 = filtered04.filter((item) => item["大カテゴリ"].includes(valueParentCategory));
              filtered05 = filtered05.filter((item) => item["大カテゴリ"].includes(valueParentCategory));
              filtered06 = filtered06.filter((item) => item["大カテゴリ"].includes(valueParentCategory));
              filtered07 = filtered07.filter((item) => item["大カテゴリ"].includes(valueParentCategory));
              filtered08 = filtered08.filter((item) => item["大カテゴリ"].includes(valueParentCategory));
              filtered09 = filtered09.filter((item) => item["大カテゴリ"].includes(valueParentCategory));
              filtered10 = filtered10.filter((item) => item["大カテゴリ"].includes(valueParentCategory));
              filtered11 = filtered11.filter((item) => item["大カテゴリ"].includes(valueParentCategory));
              filtered12 = filtered12.filter((item) => item["大カテゴリ"].includes(valueParentCategory));
              //
              filteredNextYear01 = filteredNextYear01.filter((item) => item["大カテゴリ"].includes(valueParentCategory));
              filteredNextYear02 = filteredNextYear02.filter((item) => item["大カテゴリ"].includes(valueParentCategory));
              filteredNextYear03 = filteredNextYear03.filter((item) => item["大カテゴリ"].includes(valueParentCategory));
              filteredNextYear04 = filteredNextYear04.filter((item) => item["大カテゴリ"].includes(valueParentCategory));
              filteredNextYear05 = filteredNextYear05.filter((item) => item["大カテゴリ"].includes(valueParentCategory));
              filteredNextYear06 = filteredNextYear06.filter((item) => item["大カテゴリ"].includes(valueParentCategory));
              filteredNextYear07 = filteredNextYear07.filter((item) => item["大カテゴリ"].includes(valueParentCategory));
              filteredNextYear08 = filteredNextYear08.filter((item) => item["大カテゴリ"].includes(valueParentCategory));
              filteredNextYear09 = filteredNextYear09.filter((item) => item["大カテゴリ"].includes(valueParentCategory));
              filteredNextYear10 = filteredNextYear10.filter((item) => item["大カテゴリ"].includes(valueParentCategory));
              filteredNextYear11 = filteredNextYear11.filter((item) => item["大カテゴリ"].includes(valueParentCategory));
              filteredNextYear12 = filteredNextYear12.filter((item) => item["大カテゴリ"].includes(valueParentCategory));
              //
              filteredFutureRelease = filteredFutureRelease.filter((item) => item["大カテゴリ"].includes(valueParentCategory));
            }
          }

          // フィルター 車両絞り込み
          if (this.selectedCategoryCar.length === 0) {
            // すべてをチェック状態
            this.isCheckedCategoryCar = true;
          } else {
            // すべてのチェック解除
            this.isCheckedCategoryCar = false;

            let filterConditions = []; // 空の配列を作成

            // for文を使用して値を配列に追加する
            for (let i = 0; i < this.selectedCategoryCar.length; i++) {
              if (this.selectedCategoryCar[i].includes(",")) {
                const categoryCarArray = this.selectedCategoryCar[i].split(",");
                filterConditions.push(categoryCarArray[0]);
                filterConditions.push(categoryCarArray[1]);
              } else {
                filterConditions.push(this.selectedCategoryCar[i]);
              }
            }

            // console.log("選択したもの", this.selectedCategoryCar);
            // console.log("OR検索するもの", filterConditions);

            filtered01 = filtered01.filter((item) => {
              return item["小カテゴリ"].some((category) => filterConditions.includes(category));
            });
            filtered02 = filtered02.filter((item) => {
              return item["小カテゴリ"].some((category) => filterConditions.includes(category));
            });
            filtered03 = filtered03.filter((item) => {
              return item["小カテゴリ"].some((category) => filterConditions.includes(category));
            });
            filtered04 = filtered04.filter((item) => {
              return item["小カテゴリ"].some((category) => filterConditions.includes(category));
            });
            filtered05 = filtered05.filter((item) => {
              return item["小カテゴリ"].some((category) => filterConditions.includes(category));
            });
            filtered06 = filtered06.filter((item) => {
              return item["小カテゴリ"].some((category) => filterConditions.includes(category));
            });
            filtered07 = filtered07.filter((item) => {
              return item["小カテゴリ"].some((category) => filterConditions.includes(category));
            });
            filtered08 = filtered08.filter((item) => {
              return item["小カテゴリ"].some((category) => filterConditions.includes(category));
            });
            filtered09 = filtered09.filter((item) => {
              return item["小カテゴリ"].some((category) => filterConditions.includes(category));
            });
            filtered10 = filtered10.filter((item) => {
              return item["小カテゴリ"].some((category) => filterConditions.includes(category));
            });
            filtered11 = filtered11.filter((item) => {
              return item["小カテゴリ"].some((category) => filterConditions.includes(category));
            });
            filtered12 = filtered12.filter((item) => {
              return item["小カテゴリ"].some((category) => filterConditions.includes(category));
            });
            //
            filteredNextYear01 = filteredNextYear01.filter((item) => {
              return item["小カテゴリ"].some((category) => filterConditions.includes(category));
            });
            filteredNextYear02 = filteredNextYear02.filter((item) => {
              return item["小カテゴリ"].some((category) => filterConditions.includes(category));
            });
            filteredNextYear03 = filteredNextYear03.filter((item) => {
              return item["小カテゴリ"].some((category) => filterConditions.includes(category));
            });
            filteredNextYear04 = filteredNextYear04.filter((item) => {
              return item["小カテゴリ"].some((category) => filterConditions.includes(category));
            });
            filteredNextYear05 = filteredNextYear05.filter((item) => {
              return item["小カテゴリ"].some((category) => filterConditions.includes(category));
            });
            filteredNextYear06 = filteredNextYear06.filter((item) => {
              return item["小カテゴリ"].some((category) => filterConditions.includes(category));
            });
            filteredNextYear07 = filteredNextYear07.filter((item) => {
              return item["小カテゴリ"].some((category) => filterConditions.includes(category));
            });
            filteredNextYear08 = filteredNextYear08.filter((item) => {
              return item["小カテゴリ"].some((category) => filterConditions.includes(category));
            });
            filteredNextYear09 = filteredNextYear09.filter((item) => {
              return item["小カテゴリ"].some((category) => filterConditions.includes(category));
            });
            filteredNextYear10 = filteredNextYear10.filter((item) => {
              return item["小カテゴリ"].some((category) => filterConditions.includes(category));
            });
            filteredNextYear11 = filteredNextYear11.filter((item) => {
              return item["小カテゴリ"].some((category) => filterConditions.includes(category));
            });
            filteredNextYear12 = filteredNextYear12.filter((item) => {
              return item["小カテゴリ"].some((category) => filterConditions.includes(category));
            });
            //
            filteredFutureRelease = filteredFutureRelease.filter((item) => {
              return item["小カテゴリ"].some((category) => filterConditions.includes(category));
            });
          }

          // フィルター 発売日決定
          if (this.isCheckedDecision) {
            filtered01 = filtered01.filter((item) => {
              if (item["ステータス"] === "新製品") {
                return item["発売月"].split("/").length === 3;
              }
              if (item["ステータス"] === "再生産") {
                return item["再生産日"].split("/").length === 3;
              }
            });
            filtered02 = filtered02.filter((item) => {
              if (item["ステータス"] === "新製品") {
                return item["発売月"].split("/").length === 3;
              }
              if (item["ステータス"] === "再生産") {
                return item["再生産日"].split("/").length === 3;
              }
            });
            filtered03 = filtered03.filter((item) => {
              if (item["ステータス"] === "新製品") {
                return item["発売月"].split("/").length === 3;
              }
              if (item["ステータス"] === "再生産") {
                return item["再生産日"].split("/").length === 3;
              }
            });
            filtered04 = filtered04.filter((item) => {
              if (item["ステータス"] === "新製品") {
                return item["発売月"].split("/").length === 3;
              }
              if (item["ステータス"] === "再生産") {
                return item["再生産日"].split("/").length === 3;
              }
            });
            filtered05 = filtered05.filter((item) => {
              if (item["ステータス"] === "新製品") {
                return item["発売月"].split("/").length === 3;
              }
              if (item["ステータス"] === "再生産") {
                return item["再生産日"].split("/").length === 3;
              }
            });
            filtered06 = filtered06.filter((item) => {
              if (item["ステータス"] === "新製品") {
                return item["発売月"].split("/").length === 3;
              }
              if (item["ステータス"] === "再生産") {
                return item["再生産日"].split("/").length === 3;
              }
            });
            filtered07 = filtered07.filter((item) => {
              if (item["ステータス"] === "新製品") {
                return item["発売月"].split("/").length === 3;
              }
              if (item["ステータス"] === "再生産") {
                return item["再生産日"].split("/").length === 3;
              }
            });
            filtered08 = filtered08.filter((item) => {
              if (item["ステータス"] === "新製品") {
                return item["発売月"].split("/").length === 3;
              }
              if (item["ステータス"] === "再生産") {
                return item["再生産日"].split("/").length === 3;
              }
            });
            filtered09 = filtered09.filter((item) => {
              if (item["ステータス"] === "新製品") {
                return item["発売月"].split("/").length === 3;
              }
              if (item["ステータス"] === "再生産") {
                return item["再生産日"].split("/").length === 3;
              }
            });
            filtered10 = filtered10.filter((item) => {
              if (item["ステータス"] === "新製品") {
                return item["発売月"].split("/").length === 3;
              }
              if (item["ステータス"] === "再生産") {
                return item["再生産日"].split("/").length === 3;
              }
            });
            filtered11 = filtered11.filter((item) => {
              if (item["ステータス"] === "新製品") {
                return item["発売月"].split("/").length === 3;
              }
              if (item["ステータス"] === "再生産") {
                return item["再生産日"].split("/").length === 3;
              }
            });
            filtered12 = filtered12.filter((item) => {
              if (item["ステータス"] === "新製品") {
                return item["発売月"].split("/").length === 3;
              }
              if (item["ステータス"] === "再生産") {
                return item["再生産日"].split("/").length === 3;
              }
            });
            //
            filteredNextYear01 = filteredNextYear01.filter((item) => {
              if (item["ステータス"] === "新製品") {
                return item["発売月"].split("/").length === 3;
              }
              if (item["ステータス"] === "再生産") {
                return item["再生産日"].split("/").length === 3;
              }
            });
            filteredNextYear02 = filteredNextYear02.filter((item) => {
              if (item["ステータス"] === "新製品") {
                return item["発売月"].split("/").length === 3;
              }
              if (item["ステータス"] === "再生産") {
                return item["再生産日"].split("/").length === 3;
              }
            });
            filteredNextYear03 = filteredNextYear03.filter((item) => {
              if (item["ステータス"] === "新製品") {
                return item["発売月"].split("/").length === 3;
              }
              if (item["ステータス"] === "再生産") {
                return item["再生産日"].split("/").length === 3;
              }
            });
            filteredNextYear04 = filteredNextYear04.filter((item) => {
              if (item["ステータス"] === "新製品") {
                return item["発売月"].split("/").length === 3;
              }
              if (item["ステータス"] === "再生産") {
                return item["再生産日"].split("/").length === 3;
              }
            });
            filteredNextYear05 = filteredNextYear05.filter((item) => {
              if (item["ステータス"] === "新製品") {
                return item["発売月"].split("/").length === 3;
              }
              if (item["ステータス"] === "再生産") {
                return item["再生産日"].split("/").length === 3;
              }
            });
            filteredNextYear06 = filteredNextYear06.filter((item) => {
              if (item["ステータス"] === "新製品") {
                return item["発売月"].split("/").length === 3;
              }
              if (item["ステータス"] === "再生産") {
                return item["再生産日"].split("/").length === 3;
              }
            });
            filteredNextYear07 = filteredNextYear07.filter((item) => {
              if (item["ステータス"] === "新製品") {
                return item["発売月"].split("/").length === 3;
              }
              if (item["ステータス"] === "再生産") {
                return item["再生産日"].split("/").length === 3;
              }
            });
            filteredNextYear08 = filteredNextYear08.filter((item) => {
              if (item["ステータス"] === "新製品") {
                return item["発売月"].split("/").length === 3;
              }
              if (item["ステータス"] === "再生産") {
                return item["再生産日"].split("/").length === 3;
              }
            });
            filteredNextYear09 = filteredNextYear09.filter((item) => {
              if (item["ステータス"] === "新製品") {
                return item["発売月"].split("/").length === 3;
              }
              if (item["ステータス"] === "再生産") {
                return item["再生産日"].split("/").length === 3;
              }
            });
            filteredNextYear10 = filteredNextYear10.filter((item) => {
              if (item["ステータス"] === "新製品") {
                return item["発売月"].split("/").length === 3;
              }
              if (item["ステータス"] === "再生産") {
                return item["再生産日"].split("/").length === 3;
              }
            });
            filteredNextYear11 = filteredNextYear11.filter((item) => {
              if (item["ステータス"] === "新製品") {
                return item["発売月"].split("/").length === 3;
              }
              if (item["ステータス"] === "再生産") {
                return item["再生産日"].split("/").length === 3;
              }
            });
            filteredNextYear12 = filteredNextYear12.filter((item) => {
              if (item["ステータス"] === "新製品") {
                return item["発売月"].split("/").length === 3;
              }
              if (item["ステータス"] === "再生産") {
                return item["再生産日"].split("/").length === 3;
              }
            });
            //
            filteredFutureRelease = filteredFutureRelease.filter((item) => {
              if (item["ステータス"] === "新製品") {
                return item["発売月"].split("/").length === 3;
              }
              if (item["ステータス"] === "再生産") {
                return item["再生産日"].split("/").length === 3;
              }
            });
          }

          // // フィルター 更新日
          if (valueUpdate) {
            // filtered = filtered.filter((item) => {
            //   let filterItemDate = new Date(item["更新日"]);
            //   return filterItemDate >= currentDate;
            // });
            //
            filtered01 = filtered01.filter((item) => {
              let filterItemDate = new Date(item["更新日"]);
              return filterItemDate >= currentDate;
            });
            filtered02 = filtered02.filter((item) => {
              let filterItemDate = new Date(item["更新日"]);
              return filterItemDate >= currentDate;
            });
            filtered03 = filtered03.filter((item) => {
              let filterItemDate = new Date(item["更新日"]);
              return filterItemDate >= currentDate;
            });
            filtered04 = filtered04.filter((item) => {
              let filterItemDate = new Date(item["更新日"]);
              return filterItemDate >= currentDate;
            });
            filtered05 = filtered05.filter((item) => {
              let filterItemDate = new Date(item["更新日"]);
              return filterItemDate >= currentDate;
            });
            filtered06 = filtered06.filter((item) => {
              let filterItemDate = new Date(item["更新日"]);
              return filterItemDate >= currentDate;
            });
            filtered07 = filtered07.filter((item) => {
              let filterItemDate = new Date(item["更新日"]);
              return filterItemDate >= currentDate;
            });
            filtered08 = filtered08.filter((item) => {
              let filterItemDate = new Date(item["更新日"]);
              return filterItemDate >= currentDate;
            });
            filtered09 = filtered09.filter((item) => {
              let filterItemDate = new Date(item["更新日"]);
              return filterItemDate >= currentDate;
            });
            filtered10 = filtered10.filter((item) => {
              let filterItemDate = new Date(item["更新日"]);
              return filterItemDate >= currentDate;
            });
            filtered11 = filtered11.filter((item) => {
              let filterItemDate = new Date(item["更新日"]);
              return filterItemDate >= currentDate;
            });
            filtered12 = filtered12.filter((item) => {
              let filterItemDate = new Date(item["更新日"]);
              return filterItemDate >= currentDate;
            });
            //
            filteredNextYear01 = filteredNextYear01.filter((item) => {
              let filterItemDate = new Date(item["更新日"]);
              return filterItemDate >= currentDate;
            });
            filteredNextYear02 = filteredNextYear02.filter((item) => {
              let filterItemDate = new Date(item["更新日"]);
              return filterItemDate >= currentDate;
            });
            filteredNextYear03 = filteredNextYear03.filter((item) => {
              let filterItemDate = new Date(item["更新日"]);
              return filterItemDate >= currentDate;
            });
            filteredNextYear04 = filteredNextYear04.filter((item) => {
              let filterItemDate = new Date(item["更新日"]);
              return filterItemDate >= currentDate;
            });
            filteredNextYear05 = filteredNextYear05.filter((item) => {
              let filterItemDate = new Date(item["更新日"]);
              return filterItemDate >= currentDate;
            });
            filteredNextYear06 = filteredNextYear06.filter((item) => {
              let filterItemDate = new Date(item["更新日"]);
              return filterItemDate >= currentDate;
            });
            filteredNextYear07 = filteredNextYear07.filter((item) => {
              let filterItemDate = new Date(item["更新日"]);
              return filterItemDate >= currentDate;
            });
            filteredNextYear08 = filteredNextYear08.filter((item) => {
              let filterItemDate = new Date(item["更新日"]);
              return filterItemDate >= currentDate;
            });
            filteredNextYear09 = filteredNextYear09.filter((item) => {
              let filterItemDate = new Date(item["更新日"]);
              return filterItemDate >= currentDate;
            });
            filteredNextYear10 = filteredNextYear10.filter((item) => {
              let filterItemDate = new Date(item["更新日"]);
              return filterItemDate >= currentDate;
            });
            filteredNextYear11 = filteredNextYear11.filter((item) => {
              let filterItemDate = new Date(item["更新日"]);
              return filterItemDate >= currentDate;
            });
            filteredNextYear12 = filteredNextYear12.filter((item) => {
              let filterItemDate = new Date(item["更新日"]);
              return filterItemDate >= currentDate;
            });
            //
            filteredFutureRelease = filteredFutureRelease.filter((item) => {
              let filterItemDate = new Date(item["更新日"]);
              return filterItemDate >= currentDate;
            });
          }

          // this.post = filtered;
          //
          this.post01 = filtered01;
          this.post02 = filtered02;
          this.post03 = filtered03;
          this.post04 = filtered04;
          this.post05 = filtered05;
          this.post06 = filtered06;
          this.post07 = filtered07;
          this.post08 = filtered08;
          this.post09 = filtered09;
          this.post10 = filtered10;
          this.post11 = filtered11;
          this.post12 = filtered12;
          //
          this.postNextYear01 = filteredNextYear01;
          this.postNextYear02 = filteredNextYear02;
          this.postNextYear03 = filteredNextYear03;
          this.postNextYear04 = filteredNextYear04;
          this.postNextYear05 = filteredNextYear05;
          this.postNextYear06 = filteredNextYear06;
          this.postNextYear07 = filteredNextYear07;
          this.postNextYear08 = filteredNextYear08;
          this.postNextYear09 = filteredNextYear09;
          this.postNextYear10 = filteredNextYear10;
          this.postNextYear11 = filteredNextYear11;
          this.postNextYear12 = filteredNextYear12;
          //
          this.postFutureRelease = filteredFutureRelease;

          // console.log("ステータス", valueStatus, "N/HO", valueNHO, "カテゴリ", valueParentCategory, "車両絞込", valueCategoryCar, "発売日決定", valueDecision, "更新日", valueUpdate);
          // console.log("恒久JSON", filtered);
          // console.log("出力JSON", this.post);

          // 条件なし表示フラグ
          this.displayNotFlag = this.flagAllMonthArray();

          // ローディング終了
          this.loading = false;
        },
        generatePermalink(flag, hinban) {
          // N/HOの配列内の文字列条件
          let safeflag = "";
          if (flag.includes("N") && flag.includes("HO")) {
            safeflag = "n";
          } else if (flag.includes("N")) {
            safeflag = "n";
          } else if (flag.includes("HO")) {
            safeflag = "ho";
          } else {
            safeflag = "n";
          }

          // URL生成
          const safehinban = encodeURIComponent(hinban);
          return "/" + directoryName + "/products/" + safeflag + "/" + safehinban + ".html";
        },
        generatePdf(pdf) {
          // PDF生成
          const safepdf = encodeURIComponent(pdf);
          return "/" + directoryName + "/products/img/" + safepdf + ".pdf";
        },
        // generateNHOArray(value) {
        //   console.log(value);
        //   return value;
        //   for (const aaaaaaaaaa of value) {
        //     console.log(aaaaaaaaaa);
        //   }
        // },
        generateParentCategory(value) {
          let parentCategorArray = [];
          for (const itemValue of value) {
            if (itemValue === "cat-carset" || itemValue === "ho-cat-carset") {
              parentCategorArray.push("車両");
            } else if (itemValue === "cat-rail") {
              parentCategorArray.push("レール");
            } else if (itemValue === "cat-cont") {
              parentCategorArray.push("制御機器");
            } else if (itemValue === "cat-struct") {
              parentCategorArray.push("建物");
            } else if (itemValue === "cat-etc" || itemValue === "ho-cat-etc") {
              parentCategorArray.push("その他");
            } else if (itemValue === "cat-oparts" || itemValue === "ho-cat-oparts" || itemValue === "cat-parts" || itemValue === "ho-cat-parts") {
              parentCategorArray.push("パーツ");
            }
          }
          return parentCategorArray;
        },
        // generateArray(value) {
        //   // 配列返す
        //   return value;
        // },
        generateDecision(date) {
          if (date.split("/").length === 3) {
            return true;
          }
        },
        generateDateDiff(date, status, hatubai, saisesan) {
          let getUpdateDate = currentDate;
          let getListDate = new Date(date); // JSONデータの更新日
          let outputPinkClass = "";
          let outputYellowClass = "";
          if (getListDate >= getUpdateDate) {
            // 更新日がリスト更新日も新しい場合
            outputPinkClass = " -pink";
          }
          if (status === "新製品") {
            // 発売月に日まである場合
            if (this.generateDecision(hatubai)) {
              outputYellowClass = " -yellow";
            }
          } else if (status === "再生産") {
            // 再生産日に日まである場合
            if (this.generateDecision(saisesan)) {
              outputYellowClass = " -yellow";
            }
          }
          return outputPinkClass + outputYellowClass;
        },
        generateFormatDate(date) {
          // FireFoxバグ対応;
          let dateNew = date;
          if (date.split("/").length === 2) {
            dateNew = date + "/1";
          }
          let getDate = new Date(dateNew);
          let year = getDate.getFullYear();
          let month = getDate.getMonth() + 1;
          let day = getDate.getDate();
          let textDay = day + "日";

          // 日がない場合
          if (date.split("/").length === 2) {
            textDay = "";
          }

          function isValidDate(date) {
            return date instanceof Date && !isNaN(date);
          }
          if (isValidDate(getDate)) {
            // console.log("invalidDate は有効な日付です");
            return year + "年" + month + "月" + textDay;
          } else {
            // console.log("invalidDate は無効な日付です");
            if (date === "") {
              return "-";
            } else if (date == "未定") {
              return date;
            } else {
              return year + "年" + month + "月" + textDay;
            }
          }
        },
        postGenerateArray(value) {
          // 各月のJSONデータの配列返す
          if (value === 1) {
            return this.post01;
          } else if (value === 2) {
            return this.post02;
          } else if (value === 3) {
            return this.post03;
          } else if (value === 4) {
            return this.post04;
          } else if (value === 5) {
            return this.post05;
          } else if (value === 6) {
            return this.post06;
          } else if (value === 7) {
            return this.post07;
          } else if (value === 8) {
            return this.post08;
          } else if (value === 9) {
            return this.post09;
          } else if (value === 10) {
            return this.post10;
          } else if (value === 11) {
            return this.post11;
          } else if (value === 12) {
            return this.post12;
          }
        },
        postNextYearGenerateArray(value) {
          // 来年の月のJSONデータの配列返す
          if (value === 1) {
            return this.postNextYear01;
          } else if (value === 2) {
            return this.postNextYear02;
          } else if (value === 3) {
            return this.postNextYear03;
          } else if (value === 4) {
            return this.postNextYear04;
          } else if (value === 5) {
            return this.postNextYear05;
          } else if (value === 6) {
            return this.postNextYear06;
          } else if (value === 7) {
            return this.postNextYear07;
          } else if (value === 8) {
            return this.postNextYear08;
          } else if (value === 9) {
            return this.postNextYear09;
          } else if (value === 10) {
            return this.postNextYear10;
          } else if (value === 11) {
            return this.postNextYear11;
          } else if (value === 12) {
            return this.postNextYear12;
          }
        },
        flagMonthArray(value) {
          // console.log("aaa");
          // 各月のJSONデータの空判別
          if (value === 1) {
            if (this.post01 == 0) {
              return false; // 非表示
            } else {
              return true; // 表示
            }
          } else if (value === 2) {
            if (this.post02 == 0) {
              return false; // 非表示
            } else {
              return true; // 表示
            }
          } else if (value === 3) {
            if (this.post03 == 0) {
              return false; // 非表示
            } else {
              return true; // 表示
            }
          } else if (value === 4) {
            if (this.post04 == 0) {
              return false; // 非表示
            } else {
              return true; // 表示
            }
          } else if (value === 5) {
            if (this.post05 == 0) {
              return false; // 非表示
            } else {
              return true; // 表示
            }
          } else if (value === 6) {
            if (this.post06 == 0) {
              return false; // 非表示
            } else {
              return true; // 表示
            }
          } else if (value === 7) {
            if (this.post07 == 0) {
              return false; // 非表示
            } else {
              return true; // 表示
            }
          } else if (value === 8) {
            if (this.post08 == 0) {
              return false; // 非表示
            } else {
              return true; // 表示
            }
          } else if (value === 9) {
            if (this.post09 == 0) {
              return false; // 非表示
            } else {
              return true; // 表示
            }
          } else if (value === 10) {
            if (this.post10 == 0) {
              return false; // 非表示
            } else {
              return true; // 表示
            }
          } else if (value === 11) {
            if (this.post11 == 0) {
              return false; // 非表示
            } else {
              return true; // 表示
            }
          } else if (value === 12) {
            if (this.post12 == 0) {
              return false; // 非表示
            } else {
              return true; // 表示
            }
          }
        },
        flagNextYearArray(value) {
          // 来年の各月のJSONデータの空判別
          if (value === 1) {
            if (this.postNextYear01 == 0) {
              return false; // 非表示
            } else {
              return true; // 表示
            }
          } else if (value === 2) {
            if (this.postNextYear02 == 0) {
              return false; // 非表示
            } else {
              return true; // 表示
            }
          } else if (value === 3) {
            if (this.postNextYear03 == 0) {
              return false; // 非表示
            } else {
              return true; // 表示
            }
          } else if (value === 4) {
            if (this.postNextYear04 == 0) {
              return false; // 非表示
            } else {
              return true; // 表示
            }
          } else if (value === 5) {
            if (this.postNextYear05 == 0) {
              return false; // 非表示
            } else {
              return true; // 表示
            }
          } else if (value === 6) {
            if (this.postNextYear06 == 0) {
              return false; // 非表示
            } else {
              return true; // 表示
            }
          } else if (value === 7) {
            if (this.postNextYear07 == 0) {
              return false; // 非表示
            } else {
              return true; // 表示
            }
          } else if (value === 8) {
            if (this.postNextYear08 == 0) {
              return false; // 非表示
            } else {
              return true; // 表示
            }
          } else if (value === 9) {
            if (this.postNextYear09 == 0) {
              return false; // 非表示
            } else {
              return true; // 表示
            }
          } else if (value === 10) {
            if (this.postNextYear10 == 0) {
              return false; // 非表示
            } else {
              return true; // 表示
            }
          } else if (value === 11) {
            if (this.postNextYear11 == 0) {
              return false; // 非表示
            } else {
              return true; // 表示
            }
          } else if (value === 12) {
            if (this.postNextYear12 == 0) {
              return false; // 非表示
            } else {
              return true; // 表示
            }
          }
        },
        flagAllMonthArray() {
          // 全月のJSONデータの空判別
          let displayFlag = 0;
          for (let num of this.dataRemainingMonths) {
            if (num == 1 && this.post01.length !== 0) {
              displayFlag++;
            } else if (num == 2 && this.post02.length !== 0) {
              displayFlag++;
            } else if (num == 3 && this.post03.length !== 0) {
              displayFlag++;
            } else if (num == 4 && this.post04.length !== 0) {
              displayFlag++;
            } else if (num == 5 && this.post05.length !== 0) {
              displayFlag++;
            } else if (num == 6 && this.post06.length !== 0) {
              displayFlag++;
            } else if (num == 7 && this.post07.length !== 0) {
              displayFlag++;
            } else if (num == 8 && this.post08.length !== 0) {
              displayFlag++;
            } else if (num == 9 && this.post09.length !== 0) {
              displayFlag++;
            } else if (num == 10 && this.post10.length !== 0) {
              displayFlag++;
            } else if (num == 11 && this.post11.length !== 0) {
              displayFlag++;
            } else if (num == 12 && this.post12.length !== 0) {
              displayFlag++;
            }
          }

          if (
            this.postNextYear01.length !== 0 ||
            this.postNextYear02.length !== 0 ||
            this.postNextYear03.length !== 0 ||
            this.postNextYear04.length !== 0 ||
            this.postNextYear05.length !== 0 ||
            this.postNextYear06.length !== 0 ||
            this.postNextYear07.length !== 0 ||
            this.postNextYear08.length !== 0 ||
            this.postNextYear09.length !== 0 ||
            this.postNextYear10.length !== 0 ||
            this.postNextYear11.length !== 0 ||
            this.postNextYear12.length !== 0
          ) {
            displayFlag++;
          }

          if (getType !== "past") {
            if (this.postFutureRelease.length !== 0) {
              displayFlag++;
            }
          }

          if (displayFlag === 0) {
            return true; // 表示 | 条件に一致する製品が見つかりませんでした。
          } else {
            return false; // 非表示 | 条件に一致する製品がありました。
          }
        },
      },
      created() {
        this.remainingMonths();
        this.getPosts();
      },
      updated() {
        // DOM ツリーを更新した後に呼び出し
        $(".js-faded").fadeOut(0).fadeIn(300);
      },
    });
  });

  // ==========================================================================
  // CSV：製品情報
  // ==========================================================================

  $(".js-csv-search").each(function () {
    const today = new Date();
    const todayMonth = today.getMonth() + 1; // 月は0から始まるため、+1して調整
    let todayYear = today.getFullYear();
    if (todayMonth >= 6) {
      todayYear++;
    }

    // let nextYear;

    // console.log(todayYear);
    // console.log(nextYear);

    // const getType = $(this).data("type");
    // const listUpdateDate = $(this).find("#js-schedule-date").data("update");
    // 今年の残り月数取得
    // const currentDate = new Date(listUpdateDate);
    // const currentYear = currentDate.getFullYear(); // 現在の年を取得
    // const currentMonth = currentDate.getMonth() + 1; // 現在の月を取得 (0から始まるため、1を足す)
    // const remainingMonths = []; // 残りの月数を計算 (12から現在の月を引く)
    const appElem = this;
    const app = new Vue({
      el: appElem,
      data() {
        return {
          startFade: false, //フェードするタイミング
          sidebarTiming: false,
          post: "", // 出力用JSON
          postJson: "", // フィルター用JSON
          productionSchedule01: "", // 今月生産予定
          productionSchedule02: "", // 来月生産予定
          productionSchedule03: "", // 来月以降生産予定

          filterCategory: ["", "", ""], //フィルター用 車両絞り込み [大, 小, N/HO]
          searchInput: "", // 検索：ワード
          searchYear: "", // 検索：年
          searchForYear: [],
          searchMonth: "", // 検索：月
          searchCategory: ",", // 検索：カテゴリ
          searchCategoryTitle: "",
          //
          titleNHO: "N/HOゲージ", // タイトル用
          titleCategory: "すべての製品（N/HO）", // タイトル用
          //
          titleSearch: "", // タイトル検索窓用
          titleSearchNHO: "N/HOゲージ", // タイトル検索窓用
          titleSearchCategory: "すべての製品", // タイトル検索窓用
          titleSearchYear: "", // タイトル検索窓用
          titleSearchMonth: "", // タイトル検索窓用
          //
          changeDisplay: "thumb", // 表示切替 thumbもしくはlist デフォルト：thumb
          isCheckedStock: false, //在庫・生産予定ありのみ表示のチェック判別
          selectSort: "date_desc", // ソート用データ：デフォルト：date_desc
          //
          filterNHO: "", // NHOフィルター用データ：デフォルト：絞り込みなし
          filterCategoryParent: "", // 大カテゴリーフィルター用データ：デフォルト：絞り込みなし
          filterCategoryChild: "", // 小カテゴリーフィルター用データ：デフォルト：絞り込みなし
          //
          filterSearchWord: "", // 検索文字フィルター用データ：デフォルト：絞り込みなし
          filterSearchYear: "", // 検索年フィルター用データ：デフォルト：絞り込みなし
          filterSearchMonth: "", // 検索月フィルター用データ：デフォルト：絞り込みなし
          filterSearchCategory: "", // 検索カテゴリフィルター用データ：デフォルト：絞り込みなし
          filterSearchNHO: "", // 検索NHOフィルター用データ：デフォルト：絞り込みなし
          //
          inputAddYearValue: "",
          inputAddMonthValue: "",
          inputAddCategoryValue: "",
          selectCategoryValuePc: "すべての製品", //検索窓カテゴリセレクトPC用
          //
          paramQ: "", // パラメータ用：検索ワード／デフォルト：空白
          paramYear: "", // パラメータ用：年／デフォルト：空白
          paramMonth: "", // パラメータ用：月／デフォルト：空白
          paramCategory: "", // パラメータ用：大カテゴリ／デフォルト：空白
          paramCategoryChild: "", // パラメータ用：小カテゴリ／デフォルト：空白
          paramNHO: "", // パラメータ用：NHO／デフォルト：空白
          paramSort: "date_desc", // パラメータ用：ソート／デフォルト：空白
          paramSrchmode: "all", // パラメータ用：在庫アリナシ／デフォルト：空白
          paramDisplay: "thumb", // パラメータ用：サムネ表示かリスト表示か／デフォルト：thumb
          paramPage: 1, // パラメータ用：現在のページ数／デフォルト：1ページ目
          paramflag: "category", // パラメータ用：遷移元判別／デフォルト：category
          //
          itemsPerPage: 60, // ページネーション：1ページあたり表示数
          currentPage: 1, // ページネーション：現在ページ
          //
          loading: true,
          //
          setCategoryChild: {
            catCarsetIsShow: false, // 車両フラグ
            catCarset: [
              { label: "蒸気機関車", value: "sloc" },
              { label: "電気機関車", value: "eloc" },
              { label: "ディーゼル機関車", value: "dloc" },
              { label: "新幹線", value: "sin" },
              { label: "電車", value: "ele" },
              { label: "ディーゼルカー・ハイブリット車", value: "di" },
              { label: "客車", value: "kya" },
              { label: "貨車", value: "wag" },
              { label: "私鉄・第三セクター", value: "pri" },
              { label: "試験車", value: "train" },
              { label: "スーパーセレクトセット", value: "spset" },
              { label: "ファーストカーミュージアム", value: "fcm" },
              { label: "トーマスシリーズ", value: "thomas" },
            ],
            catContIsShow: false, // 制御機器フラグ
            catCont: [
              { label: "パワーユニット", value: "cont" },
              { label: "制御機器その他", value: "contetc" },
            ],
            catRailIsShow: false, // レールフラグ
            catRail: [
              { label: "入門セット", value: "total" },
              { label: "マイプラン", value: "myplan" },
              { label: "レールセット", value: "railset" },
              { label: "レール", value: "rail" },
              { label: "レール関連", value: "railetc" },
              { label: "クリーニングシステム", value: "cleaning" },
            ],
            catStructIsShow: false, // 建物フラグ
            catStruct: [
              { label: "駅・ホーム", value: "struct" },
              { label: "建物その他", value: "structetc" },
            ],
            catEtcIsShow: false, // その他フラグ
            catEtc: [
              { label: "コンテナ", value: "container" },
              { label: "アクセサリー", value: "acces" },
              { label: "レイアウト用品", value: "layout" },
              { label: "印刷物・その他", value: "etc" },
            ],
            catOpartsShow: false, // オプションパーツフラグ
            catOparts: [
              { label: "照明ユニット", value: "lighting" },
              { label: "動力ユニット", value: "powerunit" },
              { label: "トレインマーク・ヘッドマーク", value: "trainmark" },
              { label: "交換ドアパーツ", value: "doors" },
              { label: "TNカプラー（セット）", value: "tncoupler" },
              { label: "ケース・リレーラー", value: "case" },
            ],
            catPartsShow: false, // パーツフラグ
            catParts: [
              { label: "動力台車", value: "trolley" },
              { label: "新集電台車", value: "newtrolley" },
              { label: "台車枠", value: "bogieframe" },
              { label: "カプラー", value: "coupler" },
              { label: "密連形TNカプラー", value: "mtcoupler" },
              { label: "密自連形TNカプラー", value: "mtjcoupler" },
              { label: "通電カプラー", value: "enecoupler" },
              { label: "ライト基板", value: "lightboard" },
              { label: "モーター", value: "motor" },
              { label: "シャフト", value: "shaft" },
              { label: "パンタグラフ", value: "panta" },
              { label: "屋根", value: "roof" },
              { label: "屋上機器", value: "rooftop" },
              { label: "アンテナ", value: "antenna" },
              { label: "クーラー", value: "cooler" },
              { label: "ベンチレーター", value: "ventilator" },
              { label: "車輪ゴム", value: "gom" },
              { label: "窓ガラス", value: "window" },
              { label: "集電スプリング", value: "spring" },
              { label: "スプリングウォーム", value: "springworm" },
              { label: "床下・シート", value: "seat" },
              { label: "ウォームギアセット", value: "wormgear" },
              { label: "車輪", value: "wheel" },
              { label: "床下機器", value: "under" },
              { label: "幌枠", value: "hoodframe" },
              { label: "分売パーツその他", value: "pother" },
            ],
            hoCatCarsetIsShow: false, // HO車両フラグ
            hoCatCarset: [
              { label: "電気機関車", value: "ho-eloc" },
              { label: "ディーゼル機関車", value: "ho-dloc" },
              { label: "電車", value: "ho-ele" },
              { label: "ディーゼルカー・ハイブリット車", value: "ho-di" },
              { label: "客車", value: "ho-kya" },
              { label: "貨車", value: "ho-wag" },
              { label: "私鉄", value: "ho-pri" },
            ],
            hoCatEtcIsShow: false, // HOその他フラグ
            hoCatEtc: [
              { label: "コンテナ", value: "ho-container" },
              { label: "アクセサリー", value: "ho-acces" },
            ],
            hoCatOpartsShow: false, // HOオプションパーツフラグ
            hoCatOparts: [
              { label: "室内照明ユニット", value: "ho-lighting" },
              { label: "トレインマーク", value: "ho-trainmark" },
            ],
            hoCatPartsShow: false, // HOパーツフラグ
            hoCatParts: [
              { label: "カプラー", value: "ho-coupler" },
              { label: "モーター", value: "ho-motor" },
              { label: "シート・インテリア", value: "ho-sheet" },
              { label: "車輪", value: "ho-wheel" },
              { label: "車輪ゴム", value: "ho-gom" },
              { label: "基板", value: "ho-substrate" },
              { label: "台車", value: "ho-trolley" },
              { label: "屋上機器", value: "ho-rooftop" },
              { label: "パンタグラフ", value: "ho-panta" },
              { label: "床板", value: "ho-floor" },
              { label: "分売パーツその他", value: "ho-pother" },
            ],
          },
          isSearchFlag: "", // 検索したどうかののフラグ判定用 true 1, false 0
        };
      },
      methods: {
        clickAccordion(value) {
          event.preventDefault();

          if (value === "cat-carset") {
            this.setCategoryChild.catCarsetIsShow = !this.setCategoryChild.catCarsetIsShow;
          }
          if (value === "cat-cont") {
            this.setCategoryChild.catContIsShow = !this.setCategoryChild.catContIsShow;
          }
          if (value === "cat-rail") {
            this.setCategoryChild.catRailIsShow = !this.setCategoryChild.catRailIsShow;
          }
          if (value === "cat-struct") {
            this.setCategoryChild.catStructIsShow = !this.setCategoryChild.catStructIsShow;
          }
          if (value === "cat-etc") {
            this.setCategoryChild.catEtcIsShow = !this.setCategoryChild.catEtcIsShow;
          }
          if (value === "cat-oparts") {
            this.setCategoryChild.catOpartsShow = !this.setCategoryChild.catOpartsShow;
          }
          if (value === "cat-parts") {
            this.setCategoryChild.catPartsShow = !this.setCategoryChild.catPartsShow;
          }

          if (value === "ho-cat-carset") {
            this.setCategoryChild.hoCatCarsetIsShow = !this.setCategoryChild.hoCatCarsetIsShow;
          }

          if (value === "ho-cat-etc") {
            this.setCategoryChild.hoCatEtcIsShow = !this.setCategoryChild.hoCatEtcIsShow;
          }

          if (value === "ho-cat-oparts") {
            this.setCategoryChild.hoCatOpartsShow = !this.setCategoryChild.hoCatOpartsShow;
          }

          if (value === "ho-cat-parts") {
            this.setCategoryChild.hoCatPartsShow = !this.setCategoryChild.hoCatPartsShow;
          }
        },
        enter(el) {
          const height = getComputedStyle(el).height;
          el.style.width = null;
          el.style.position = null;
          el.style.visibility = null;
          el.style.height = 0;

          // Force repaint to make sure the
          // animation is triggered correctly.
          getComputedStyle(el).height;

          requestAnimationFrame(() => {
            el.style.height = height;
          });
        },
        afterEnter(el) {
          el.style.height = "auto";
        },
        leave(el) {
          const height = getComputedStyle(el).height;
          el.style.height = height;

          // Force repaint to make sure the
          // animation is triggered correctly.
          getComputedStyle(el).height;
          requestAnimationFrame(() => {
            el.style.height = "0";
          });
        },
        afterLeave(el) {
          el.style.height = "auto";
        },
        getPosts() {
          // CSV読み込み
          $.ajax({
            dataType: "text", //text,json,jsonp,xml,html,script
            url: csvFile, //読み込むファイル指定
            cache: false,
            // success: function (data) {},
            // Shift-JIS変換
            beforeSend: function (xhr) {
              // xhr.overrideMimeType("text/html;charset=SJIS");
              xhr.overrideMimeType("text/html;charset=Shift-JIS"); //SJIS、Shift-JISいずれでも可能だった。
            },
          })
            .done((csvData) => {
              // 半角英数字、全角カタカナ変換
              let conv_hankaku = convertToHalfWidth(csvData);
              let conv_katakana = convertToFullWidthKatakana(conv_hankaku);

              // CSVデータ
              // console.log("CSVデータ", conv_katakana);

              // CSVの一行目JSON化

              const first_row = conv_katakana.slice(0, conv_katakana.indexOf("\n"));
              const first_row_array = first_row.split(",");
              // console.log("CSVの一行目JSON化", first_row_array);
              this.productionSchedule01 = first_row_array[7]; // 今月生産予定
              this.productionSchedule02 = first_row_array[8]; // 来月生産予定
              this.productionSchedule03 = first_row_array[9]; // 来月以降生産予定

              // 成功
              // CSVTOJSON
              csv({
                output: "json",
              })
                .fromString(conv_katakana)
                .then((json) => {
                  // 最新年取得
                  for (let i = todayYear; i >= 1976; i--) {
                    this.searchForYear.push(i);
                  }

                  // 指定した列の文字列をカンマ区切りで分割し、配列化する
                  json.forEach((item) => {
                    item["N/HO"] = item["N/HO"].split(",").map((value) => value.trim());
                    item["大カテゴリ"] = item["大カテゴリ"].split(",").map((value) => value.trim());
                    item["小カテゴリ"] = item["小カテゴリ"].split(",").map((value) => value.trim());
                    item["備考"] = item["備考"].split(",").map((value) => value.trim());
                  });

                  // データ格納
                  this.post = json;
                  this.postJson = json;
                  let defaultFilter = this.postJson;

                  // パラメータ取得
                  const url = new URL(window.location.href); // URLを取得
                  const params = url.searchParams; // URLSearchParamsオブジェクトを取得
                  const getParamsQ = params.get("q"); // ワード
                  const getParamsYear = params.get("year"); // 年
                  const getParamsMonth = params.get("month"); // 月
                  const getParamsCategory = params.get("category"); // 大カテゴリ
                  const getParamsCategoryChild = params.get("category_child"); // 小カテゴリ
                  const getParamsNHO = params.get("nho"); // NHO
                  const getParamsSort = params.get("sort"); // ソート
                  const getParamsStock = params.get("srchmode"); // 在庫アリナシ
                  const getParamsDisplay = params.get("display"); // サムネ表示かリスト表示か
                  const getParamsPage = params.get("page"); // 現在ページ
                  const getParamsFlag = params.get("flag"); // 遷移元判別

                  // console.log("パラメータ：ワード", getParamsQ);
                  // console.log("パラメータ：年", getParamsYear);
                  // console.log("パラメータ：月", getParamsMonth);
                  // console.log("パラメータ：大カテゴリ", getParamsCategory);
                  // console.log("パラメータ：小カテゴリ", getParamsCategoryChild);
                  // console.log("パラメータ：NHO", getParamsNHO);
                  // console.log("パラメータ：ソート", getParamsSort);
                  // console.log("パラメータ：在庫アリナシ", getParamsStock);
                  // console.log("パラメータ：サムネ表示かリスト表示か", getParamsDisplay);
                  // console.log("パラメータ：現在ページ", getParamsPage);
                  // console.log("パラメータ：遷移元判別", getParamsFlag);

                  // パラメータ：フィルター

                  // 遷移元判別
                  if (getParamsFlag) {
                    const dateFlag = getParamsFlag;
                    if (dateFlag == "category") {
                      this.paramflag = "category"; //遷移元判別
                    } else if (dateFlag == "search") {
                      this.paramflag = "search"; //遷移元判別
                    }
                  }

                  // 遷移元判別：category
                  if (this.paramflag == "category") {
                    // console.log("category");

                    if (getParamsCategory) {
                      const dateCategory = getParamsCategory;
                      this.filterCategoryParent = dateCategory; // 大カテゴリーフィルター用データ：デフォルト：絞り込みなし

                      // タイトル・アコーディオン
                      if (dateCategory === "cat-carset" || dateCategory === "ho-cat-carset") {
                        this.titleCategory = "すべての車両";
                        if (dateCategory.includes("ho-")) {
                          this.setCategoryChild.hoCatCarsetIsShow = true;
                        } else {
                          this.setCategoryChild.catCarsetIsShow = true;
                        }
                      }
                      if (dateCategory === "cat-cont") {
                        this.titleCategory = "すべての制御機器";
                        this.setCategoryChild.catContIsShow = true;
                      }
                      if (dateCategory === "cat-rail") {
                        this.titleCategory = "すべてのレール";
                        this.setCategoryChild.catRailIsShow = true;
                      }
                      if (dateCategory === "cat-struct") {
                        this.titleCategory = "すべての建物";
                        this.setCategoryChild.catStructIsShow = true;
                      }
                      if (dateCategory === "cat-etc" || dateCategory === "ho-cat-etc") {
                        this.titleCategory = "すべてのその他";
                        if (dateCategory.includes("ho-")) {
                          this.setCategoryChild.hoCatEtcIsShow = true;
                        } else {
                          this.setCategoryChild.catEtcIsShow = true;
                        }
                      }
                      if (dateCategory === "cat-oparts" || dateCategory === "ho-cat-oparts") {
                        this.titleCategory = "すべてのオプショナルパーツ";
                        if (dateCategory.includes("ho-")) {
                          this.setCategoryChild.hoCatOpartsShow = true;
                        } else {
                          this.setCategoryChild.catOpartsShow = true;
                        }
                      }
                      if (dateCategory === "cat-parts" || dateCategory === "ho-cat-parts") {
                        this.titleCategory = "すべての分売パーツ";
                        if (dateCategory.includes("ho-")) {
                          this.setCategoryChild.hoCatPartsShow = true;
                        } else {
                          this.setCategoryChild.catPartsShow = true;
                        }
                      }

                      if (dateCategory.includes("ho-")) {
                        this.titleNHO = "HOゲージ";
                      } else {
                        this.titleNHO = "Nゲージ";
                      }

                      // フィルター
                      defaultFilter = defaultFilter.filter((item) => item["大カテゴリ"].includes(dateCategory));
                    }

                    if (getParamsCategoryChild) {
                      const dateCategoryChild = getParamsCategoryChild;
                      this.filterCategoryChild = dateCategoryChild; // 小カテゴリーフィルター用データ：デフォルト：絞り込みなし

                      // タイトル・アコーディオン
                      if (dateCategoryChild === "sloc") {
                        this.titleCategory = "蒸気機関車";
                        this.setCategoryChild.catCarsetIsShow = true;
                      }
                      if (dateCategoryChild === "eloc" || dateCategoryChild === "ho-eloc") {
                        this.titleCategory = "電気機関車";
                        if (dateCategoryChild.includes("ho-")) {
                          this.setCategoryChild.hoCatCarsetIsShow = true;
                        } else {
                          this.setCategoryChild.catCarsetIsShow = true;
                        }
                      }
                      if (dateCategoryChild === "dloc" || dateCategoryChild === "ho-dloc") {
                        this.titleCategory = "ディーゼル機関車";
                        if (dateCategoryChild.includes("ho-")) {
                          this.setCategoryChild.hoCatCarsetIsShow = true;
                        } else {
                          this.setCategoryChild.catCarsetIsShow = true;
                        }
                      }
                      if (dateCategoryChild === "sin") {
                        this.titleCategory = "新幹線";
                        this.setCategoryChild.catCarsetIsShow = true;
                      }
                      if (dateCategoryChild === "ele" || dateCategoryChild === "ho-ele") {
                        this.titleCategory = "電車";
                        if (dateCategoryChild.includes("ho-")) {
                          this.setCategoryChild.hoCatCarsetIsShow = true;
                        } else {
                          this.setCategoryChild.catCarsetIsShow = true;
                        }
                      }
                      if (dateCategoryChild === "di" || dateCategoryChild === "ho-di") {
                        this.titleCategory = "ディーゼルカー・ハイブリット車";
                        if (dateCategoryChild.includes("ho-")) {
                          this.setCategoryChild.hoCatCarsetIsShow = true;
                        } else {
                          this.setCategoryChild.catCarsetIsShow = true;
                        }
                      }
                      if (dateCategoryChild === "kya" || dateCategoryChild === "ho-kya") {
                        this.titleCategory = "客車";
                        if (dateCategoryChild.includes("ho-")) {
                          this.setCategoryChild.hoCatCarsetIsShow = true;
                        } else {
                          this.setCategoryChild.catCarsetIsShow = true;
                        }
                      }
                      if (dateCategoryChild === "wag" || dateCategoryChild === "ho-wag") {
                        this.titleCategory = "貨車";
                        if (dateCategoryChild.includes("ho-")) {
                          this.setCategoryChild.hoCatCarsetIsShow = true;
                        } else {
                          this.setCategoryChild.catCarsetIsShow = true;
                        }
                      }
                      if (dateCategoryChild === "pri") {
                        this.titleCategory = "私鉄・第三セクター";
                        this.setCategoryChild.catCarsetIsShow = true;
                      }
                      if (dateCategoryChild === "ho-pri") {
                        this.titleCategory = "私鉄";
                        this.setCategoryChild.hoCatCarsetIsShow = true;
                      }
                      if (dateCategoryChild === "train") {
                        this.titleCategory = "試験車";
                        this.setCategoryChild.catCarsetIsShow = true;
                      }
                      if (dateCategoryChild === "spset") {
                        this.titleCategory = "スーパーセレクトセット";
                        this.setCategoryChild.catCarsetIsShow = true;
                      }
                      if (dateCategoryChild === "fcm") {
                        this.titleCategory = "ファーストカーミュージアム";
                        this.setCategoryChild.catCarsetIsShow = true;
                      }
                      if (dateCategoryChild === "thomas") {
                        this.titleCategory = "トーマスシリーズ";
                        this.setCategoryChild.catCarsetIsShow = true;
                      }

                      if (dateCategoryChild === "cont") {
                        this.titleCategory = "パワーユニット";
                        this.setCategoryChild.catContIsShow = true;
                      }
                      if (dateCategoryChild === "contetc") {
                        this.titleCategory = "制御機器その他";
                        this.setCategoryChild.catContIsShow = true;
                      }

                      if (dateCategoryChild === "total") {
                        this.titleCategory = "入門セット";
                        this.setCategoryChild.catRailIsShow = true;
                      }
                      if (dateCategoryChild === "myplan") {
                        this.titleCategory = "マイプラン";
                        this.setCategoryChild.catRailIsShow = true;
                      }
                      if (dateCategoryChild === "railset") {
                        this.titleCategory = "レールセット";
                        this.setCategoryChild.catRailIsShow = true;
                      }
                      if (dateCategoryChild === "rail") {
                        this.titleCategory = "レール";
                        this.setCategoryChild.catRailIsShow = true;
                      }
                      if (dateCategoryChild === "railetc") {
                        this.titleCategory = "レール関連";
                        this.setCategoryChild.catRailIsShow = true;
                      }
                      if (dateCategoryChild === "cleaning") {
                        this.titleCategory = "クリーニングシステム";
                        this.setCategoryChild.catRailIsShow = true;
                      }

                      if (dateCategoryChild === "struct") {
                        this.titleCategory = "駅・ホーム";
                        this.setCategoryChild.catStructIsShow = true;
                      }
                      if (dateCategoryChild === "structetc") {
                        this.titleCategory = "建物その他";
                        this.setCategoryChild.catStructIsShow = true;
                      }

                      if (dateCategoryChild === "container" || dateCategoryChild === "ho-container") {
                        this.titleCategory = "コンテナ";
                        if (dateCategoryChild.includes("ho-")) {
                          this.setCategoryChild.hoCatEtcIsShow = true;
                        } else {
                          this.setCategoryChild.catEtcIsShow = true;
                        }
                      }
                      if (dateCategoryChild === "acces" || dateCategoryChild === "ho-acces") {
                        this.titleCategory = "アクセサリー";
                        if (dateCategoryChild.includes("ho-")) {
                          this.setCategoryChild.hoCatEtcIsShow = true;
                        } else {
                          this.setCategoryChild.catEtcIsShow = true;
                        }
                      }
                      if (dateCategoryChild === "layout") {
                        this.titleCategory = "レイアウト用品";
                        this.setCategoryChild.catEtcIsShow = true;
                      }
                      if (dateCategoryChild === "etc") {
                        this.titleCategory = "印刷物・その他";
                        this.setCategoryChild.catEtcIsShow = true;
                      }

                      if (dateCategoryChild === "lighting") {
                        this.titleCategory = "照明ユニット";
                        this.setCategoryChild.catOpartsShow = true;
                      }
                      if (dateCategoryChild === "powerunit") {
                        this.titleCategory = "動力ユニット";
                        this.setCategoryChild.catOpartsShow = true;
                      }
                      if (dateCategoryChild === "trainmark") {
                        this.titleCategory = "トレインマーク・ヘッドマーク";
                        this.setCategoryChild.catOpartsShow = true;
                      }
                      if (dateCategoryChild === "doors") {
                        this.titleCategory = "交換ドアパーツ";
                        this.setCategoryChild.catOpartsShow = true;
                      }
                      if (dateCategoryChild === "tncoupler") {
                        this.titleCategory = "TNカプラー（セット）";
                        this.setCategoryChild.catOpartsShow = true;
                      }
                      if (dateCategoryChild === "case") {
                        this.titleCategory = "ケース・リレーラー";
                        this.setCategoryChild.catOpartsShow = true;
                      }
                      if (dateCategoryChild === "ho-lighting") {
                        this.titleCategory = "室内照明ユニット";
                        this.setCategoryChild.hoCatOpartsShow = true;
                      }
                      if (dateCategoryChild === "ho-trainmark") {
                        this.titleCategory = "トレインマーク";
                        this.setCategoryChild.hoCatOpartsShow = true;
                      }

                      if (dateCategoryChild === "trolley") {
                        this.titleCategory = "動力台車";
                        this.setCategoryChild.catPartsShow = true;
                      }
                      if (dateCategoryChild === "newtrolley") {
                        this.titleCategory = "新集電台車";
                        this.setCategoryChild.catPartsShow = true;
                      }
                      if (dateCategoryChild === "bogieframe") {
                        this.titleCategory = "台車枠";
                        this.setCategoryChild.catPartsShow = true;
                      }
                      if (dateCategoryChild === "coupler" || dateCategoryChild === "ho-coupler") {
                        this.titleCategory = "カプラー";
                        if (dateCategoryChild.includes("ho-")) {
                          this.setCategoryChild.hoCatPartsShow = true;
                        } else {
                          this.setCategoryChild.catPartsShow = true;
                        }
                      }
                      if (dateCategoryChild === "mtcoupler") {
                        this.titleCategory = "密連形TNカプラー";
                        this.setCategoryChild.catPartsShow = true;
                      }
                      if (dateCategoryChild === "mtjcoupler") {
                        this.titleCategory = "密自連形TNカプラー";
                        this.setCategoryChild.catPartsShow = true;
                      }
                      if (dateCategoryChild === "enecoupler") {
                        this.titleCategory = "通電カプラー";
                        this.setCategoryChild.catPartsShow = true;
                      }
                      if (dateCategoryChild === "lightboard") {
                        this.titleCategory = "ライト基板";
                        this.setCategoryChild.catPartsShow = true;
                      }
                      if (dateCategoryChild === "motor" || dateCategoryChild === "ho-motor") {
                        this.titleCategory = "モーター";
                        if (dateCategoryChild.includes("ho-")) {
                          this.setCategoryChild.hoCatPartsShow = true;
                        } else {
                          this.setCategoryChild.catPartsShow = true;
                        }
                      }
                      if (dateCategoryChild === "shaft") {
                        this.titleCategory = "シャフト";
                        this.setCategoryChild.catPartsShow = true;
                      }
                      if (dateCategoryChild === "panta" || dateCategoryChild === "ho-panta") {
                        this.titleCategory = "パンタグラフ";
                        if (dateCategoryChild.includes("ho-")) {
                          this.setCategoryChild.hoCatPartsShow = true;
                        } else {
                          this.setCategoryChild.catPartsShow = true;
                        }
                      }
                      if (dateCategoryChild === "roof") {
                        this.titleCategory = "屋根";
                        this.setCategoryChild.catPartsShow = true;
                      }
                      if (dateCategoryChild === "rooftop" || dateCategoryChild === "ho-rooftop") {
                        this.titleCategory = "屋上機器";
                        if (dateCategoryChild.includes("ho-")) {
                          this.setCategoryChild.hoCatPartsShow = true;
                        } else {
                          this.setCategoryChild.catPartsShow = true;
                        }
                      }
                      if (dateCategoryChild === "antenna") {
                        this.titleCategory = "アンテナ";
                        this.setCategoryChild.catPartsShow = true;
                      }
                      if (dateCategoryChild === "cooler") {
                        this.titleCategory = "クーラー";
                        this.setCategoryChild.catPartsShow = true;
                      }
                      if (dateCategoryChild === "ventilator") {
                        this.titleCategory = "ベンチレーター";
                        this.setCategoryChild.catPartsShow = true;
                      }
                      if (dateCategoryChild === "gom" || dateCategoryChild === "ho-gom") {
                        this.titleCategory = "車輪ゴム";
                        if (dateCategoryChild.includes("ho-")) {
                          this.setCategoryChild.hoCatPartsShow = true;
                        } else {
                          this.setCategoryChild.catPartsShow = true;
                        }
                      }
                      if (dateCategoryChild === "window") {
                        this.titleCategory = "窓ガラス";
                        this.setCategoryChild.catPartsShow = true;
                      }
                      if (dateCategoryChild === "spring") {
                        this.titleCategory = "集電スプリング";
                        this.setCategoryChild.catPartsShow = true;
                      }
                      if (dateCategoryChild === "springworm") {
                        this.titleCategory = "スプリングウォーム";
                        this.setCategoryChild.catPartsShow = true;
                      }
                      if (dateCategoryChild === "seat") {
                        this.titleCategory = "床下・シート";
                        this.setCategoryChild.catPartsShow = true;
                      }
                      if (dateCategoryChild === "wormgear") {
                        this.titleCategory = "ウォームギアセット";
                        this.setCategoryChild.catPartsShow = true;
                      }
                      if (dateCategoryChild === "wheel" || dateCategoryChild === "ho-wheel") {
                        this.titleCategory = "車輪";
                        if (dateCategoryChild.includes("ho-")) {
                          this.setCategoryChild.hoCatPartsShow = true;
                        } else {
                          this.setCategoryChild.catPartsShow = true;
                        }
                      }
                      if (dateCategoryChild === "under") {
                        this.titleCategory = "床下機器";
                        this.setCategoryChild.catPartsShow = true;
                      }
                      if (dateCategoryChild === "hoodframe") {
                        this.titleCategory = "幌枠";
                        this.setCategoryChild.catPartsShow = true;
                      }
                      if (dateCategoryChild === "pother" || dateCategoryChild === "ho-pother") {
                        this.titleCategory = "分売パーツその他";
                        if (dateCategoryChild.includes("ho-")) {
                          this.setCategoryChild.hoCatPartsShow = true;
                        } else {
                          this.setCategoryChild.catPartsShow = true;
                        }
                      }
                      if (dateCategoryChild === "ho-sheet") {
                        this.titleCategory = "シート・インテリア";
                        this.setCategoryChild.hoCatPartsShow = true;
                      }
                      if (dateCategoryChild === "ho-substrate") {
                        this.titleCategory = "基板";
                        this.setCategoryChild.hoCatPartsShow = true;
                      }
                      if (dateCategoryChild === "ho-trolley") {
                        this.titleCategory = "台車";
                        this.setCategoryChild.hoCatPartsShow = true;
                      }
                      if (dateCategoryChild === "ho-floor") {
                        this.titleCategory = "床板";
                        this.setCategoryChild.hoCatPartsShow = true;
                      }

                      if (dateCategoryChild.includes("ho-")) {
                        this.titleNHO = "HOゲージ";
                      } else {
                        this.titleNHO = "Nゲージ";
                      }

                      // フィルター
                      defaultFilter = defaultFilter.filter((item) => item["小カテゴリ"].includes(dateCategoryChild));
                    }

                    if (getParamsNHO) {
                      const dateNHO = getParamsNHO;
                      this.filterNHO = dateNHO; //フィルター用 N/HO
                      // タイトル用・フィルター
                      if (dateNHO === "N") {
                        this.titleNHO = "Nゲージ";
                        this.titleCategory = "すべての製品";
                        defaultFilter = defaultFilter.filter((item) => item["N/HO"].includes("N") || item["N/HO"].includes(""));
                      }
                      if (dateNHO === "HO") {
                        this.titleNHO = "HOゲージ";
                        this.titleCategory = "すべての製品";
                        defaultFilter = defaultFilter.filter((item) => item["N/HO"].includes("HO"));
                      }
                    }
                  }

                  // 遷移元判別：search
                  if (this.paramflag == "search") {
                    // console.log("search");
                    if (getParamsQ) {
                      const dateWord = getParamsQ;
                      this.filterSearchWord = dateWord; //フィルター用
                      this.titleSearch = dateWord; // タイトル用

                      // 最後の文字が「系」もしくは「番代」という単語だったら削除
                      let getParamsQSlice = getParamsQ;
                      if (getParamsQSlice.slice(-1) === "系") {
                        getParamsQSlice = getParamsQSlice.slice(0, -1);
                      } else if (getParamsQSlice.slice(-2) === "番代") {
                        getParamsQSlice = getParamsQSlice.slice(0, -2);
                      }

                      defaultFilter = defaultFilter.filter((item) => item["品番"].indexOf(dateWord) > -1 || item["商　品　名"].indexOf(getParamsQSlice.toLowerCase()) > -1 || item["商　品　名"].indexOf(getParamsQSlice.toUpperCase()) > -1 || item["在庫"].indexOf(dateWord) > -1 || item["JANコード"] === dateWord);
                    }

                    if (getParamsYear) {
                      const dateYear = getParamsYear;
                      this.inputAddYearValue = dateYear; //検索窓のデータ送信用
                      this.filterSearchYear = dateYear;
                      this.titleSearchYear = dateYear; // タイトル用
                      defaultFilter = this.filterYear(defaultFilter, dateYear);
                    }

                    if (getParamsMonth) {
                      const dateMonth = getParamsMonth;
                      this.inputAddMonthValue = dateMonth; //検索窓のデータ送信用
                      this.filterSearchMonth = dateMonth;
                      this.titleSearchMonth = dateMonth; // タイトル用
                      defaultFilter = this.filterMonth(defaultFilter, dateMonth);
                    }

                    if (getParamsCategory) {
                      const dateCategory = getParamsCategory;
                      this.inputAddCategoryValue = dateCategory; //検索窓のデータ送信用
                      this.filterSearchCategory = getParamsNHO;
                      // タイトル用
                      if (dateCategory === "cat-carset" || dateCategory === "ho-cat-carset") {
                        this.selectCategoryValuePc = "車両";
                        this.titleSearchCategory = "車両";
                      }
                      if (dateCategory === "cat-cont") {
                        this.selectCategoryValuePc = "制御機器";
                        this.titleSearchCategory = "制御機器";
                      }
                      if (dateCategory === "cat-rail") {
                        this.selectCategoryValuePc = "レール";
                        this.titleSearchCategory = "レール";
                      }
                      if (dateCategory === "cat-struct") {
                        this.selectCategoryValuePc = "建物";
                        this.titleSearchCategory = "建物";
                      }
                      if (dateCategory === "cat-etc" || dateCategory === "ho-cat-etc") {
                        this.selectCategoryValuePc = "その他";
                        this.titleSearchCategory = "その他";
                      }
                      if (dateCategory === "cat-oparts" || dateCategory === "ho-cat-oparts") {
                        this.selectCategoryValuePc = "オプショナルパーツ";
                        this.titleSearchCategory = "オプショナルパーツ";
                      }
                      if (dateCategory === "cat-parts" || dateCategory === "ho-cat-parts") {
                        this.selectCategoryValuePc = "分売パーツ";
                        this.titleSearchCategory = "分売パーツ";
                      }

                      if (dateCategory.includes("ho-")) {
                        this.titleSearchNHO = "HOゲージ";
                      } else {
                        this.titleSearchNHO = "Nゲージ";
                      }

                      // フィルター
                      defaultFilter = defaultFilter.filter((item) => item["大カテゴリ"].includes(dateCategory));
                    }

                    if (getParamsNHO) {
                      const dateNHO = getParamsNHO;
                      this.inputAddCategoryValue = getParamsNHO; //検索窓のデータ送信用
                      this.filterSearchNHO = getParamsNHO;
                      // タイトル用・フィルター
                      if (dateNHO === "N") {
                        this.titleSearchNHO = "Nゲージ";
                        defaultFilter = defaultFilter.filter((item) => item["N/HO"].includes("N") || item["N/HO"].includes(""));
                      }
                      if (dateNHO === "HO") {
                        this.titleSearchNHO = "HOゲージ";
                        defaultFilter = defaultFilter.filter((item) => item["N/HO"].includes("HO"));
                      }
                    }

                    // クリア
                    this.setCategoryChild.catCarsetIsShow = false;
                  }

                  // ソート
                  if (getParamsSort) {
                    const dateSort = getParamsSort;
                    this.selectSort = dateSort;
                  }

                  //在庫
                  if (getParamsStock) {
                    const dateStock = getParamsStock;
                    if (dateStock === "select") {
                      this.isCheckedStock = true; //在庫・生産予定ありのみ表示のチェック判別
                      defaultFilter = defaultFilter.filter(
                        (item) =>
                          item["在庫"] !== "" ||
                          item[this.productionSchedule01] === "○" ||
                          item[this.productionSchedule01].includes("発売予定") ||
                          item[this.productionSchedule01].includes("未定") ||
                          item[this.productionSchedule02] === "○" ||
                          item[this.productionSchedule02].includes("発売予定") ||
                          item[this.productionSchedule02].includes("未定") ||
                          item[this.productionSchedule03] !== ""
                      );
                    }
                  }

                  // 表示切り替え
                  if (getParamsDisplay) {
                    const dateDisplay = getParamsDisplay;
                    if (dateDisplay === "thumb") {
                      this.changeDisplay = "thumb"; // 表示切替 thumbもしくはlist デフォルト：thumb
                    }

                    if (dateDisplay === "list") {
                      this.changeDisplay = "list"; // 表示切替 thumbもしくはlist デフォルト：thumb
                    }
                  }

                  // 現在ページ
                  if (getParamsPage) {
                    const datePage = getParamsPage;
                    this.currentPage = datePage; // ページネーション：現在ページ
                  }

                  // フィルター結果格納
                  this.post = defaultFilter;

                  // ソート
                  this.selectChangeSort();

                  // ローディング終了
                  this.loading = false;

                  // サイドバーの展開遅らせる
                  if (!this.loading) {
                    setTimeout(() => {
                      this.sidebarTiming = true;
                    }, 800);
                  }
                });
            })
            .fail(() => {
              // 失敗
            })
            .always(() => {
              // fail を含め処理が完了したときに起動
            });
        },
        filterYear(json, year) {
          // 年のフィルター
          return json.filter((item) => {
            // FireFoxバグ対応
            if (item["発売月"].split("/").length === 2) {
              item["発売月"] = item["発売月"] + "/1";
            }
            const itemDate = new Date(item["発売月"]); // JSON内の日付をDateオブジェクトに変換
            return (
              itemDate.getFullYear() === Number(year) // JavaScriptの月は0から始まるため、1を引く
            );
          });
        },
        filterMonth(json, month) {
          // 月のフィルター
          return json.filter((item) => {
            // FireFoxバグ対応
            if (item["発売月"].split("/").length === 2) {
              item["発売月"] = item["発売月"] + "/1";
            }
            const itemDate = new Date(item["発売月"]); // JSON内の日付をDateオブジェクトに変換
            return (
              itemDate.getMonth() === Number(month) - 1 // JavaScriptの月は0から始まるため、1を引く
            );
          });
        },
        formatDate(dateString) {
          if (dateString === "" || dateString === "未定") {
            return "未定";
          } else {
            // FireFoxバグ対応
            if (dateString.split("/").length === 2) {
              dateString = dateString + "/1";
            }
            // データフォーマットに変換
            const dateObject = new Date(dateString);
            // 年月を取得
            const year = dateObject.getFullYear();
            const month = dateObject.getMonth() + 1;
            // 年月で出力
            return year + "年" + month + "月発売";
          }
        },
        formatDateList(dateString) {
          if (dateString === "" || dateString === "未定") {
            return "未定";
          } else {
            // FireFoxバグ対応
            if (dateString.split("/").length === 2) {
              dateString = dateString + "/1";
            }
            // データフォーマットに変換
            const dateObject = new Date(dateString);
            // 年月を取得
            const year = dateObject.getFullYear();
            const month = dateObject.getMonth() + 1;
            // 年月で出力
            return year + "年" + month + "月";
          }
        },
        // generateFormatDate(date, flag) {
        //   let getDate = new Date(date);
        //   let year = getDate.getFullYear();
        //   let month = getDate.getMonth() + 1;
        //   let text = "";
        //   if (flag) {
        //     text = "発売";
        //   }

        //   function isValidDate(date) {
        //     return date instanceof Date && !isNaN(date);
        //   }
        //   if (isValidDate(getDate)) {
        //     // console.log("invalidDate は有効な日付です");
        //     return year + "年" + month + "月" + text;
        //   } else {
        //     // console.log("invalidDate は無効な日付です");
        //     if (date === "") {
        //       return "-";
        //     } else {
        //       return date;
        //     }
        //   }
        // },
        generatePermalink(flag, hinban) {
          // N/HOの配列内の文字列条件
          let safeflag = "";
          if (flag.includes("N") && flag.includes("HO")) {
            safeflag = "n";
          } else if (flag.includes("N")) {
            safeflag = "n";
          } else if (flag.includes("HO")) {
            safeflag = "ho";
          } else {
            safeflag = "n";
          }
          // URL生成
          const safehinban = encodeURIComponent(hinban);
          return "/" + directoryName + "/products/" + safeflag + "/" + safehinban + ".html";
        },
        generateImg(hinban) {
          // IMG生成
          const safehinban = encodeURIComponent(hinban);
          return "/" + directoryName + "/products/img/" + safehinban + "_s.jpg";
        },
        clickChangeDisplay(value) {
          // console.log("表示切り替え", value);

          // フェードスタート
          this.startFade = true;

          // 表示切り替え
          this.changeDisplay = value;

          // パラメータを上書き・更新
          const currentURL = window.location.href;
          const url = new URL(currentURL);
          const params = new URLSearchParams(url.search);
          this.paramDisplay = this.changeDisplay;
          params.set("display", this.paramDisplay);
          url.search = params.toString();
          const newURL = url.toString();
          history.replaceState(null, null, newURL);
        },
        clickFilterStock() {
          // console.log("在庫・生産予定ありのみ表示");

          // params.set("srchmode", this.paramSrchmode);
          // console.log(this.isCheckedStock);
          // console.log(this.paramSrchmode);

          // パラメータを上書き・更新
          const currentURL = window.location.href;
          const url = new URL(currentURL);
          const params = new URLSearchParams(url.search);
          if (this.isCheckedStock) {
            this.paramSrchmode = "select";
          } else {
            this.paramSrchmode = "all";
          }
          params.set("srchmode", this.paramSrchmode);
          url.search = params.toString();
          const newURL = url.toString();
          history.replaceState(null, null, newURL);

          // フィルター：在庫・生産予定ありのみ表示
          if (this.paramflag == "category") {
            this.setFilter(this.isCheckedStock, this.filterNHO, this.filterCategoryParent, this.filterCategoryChild, this.searchInput, this.searchYear, this.searchMonth);
          } else if (this.paramflag == "search") {
            // console.log(this.filterSearchCategory);
            // console.log(this.filterSearchNHO);
            // console.log(this.filterSearchWord);
            // console.log(this.filterSearchYear);
            // console.log(this.filterSearchMonth);
            this.setFilter(this.isCheckedStock, this.filterSearchNHO, this.filterSearchCategory, this.filterCategoryChild, this.filterSearchWord, this.filterSearchYear, this.filterSearchMonth);
          } else {
            this.setFilter(this.isCheckedStock, this.filterNHO, this.filterCategoryParent, this.filterCategoryChild, this.searchInput, this.searchYear, this.searchMonth);
          }
        },
        clickFilterNHO(value) {
          event.preventDefault();

          // タイトル用
          if (value === "N") {
            this.titleNHO = "Nゲージ";
            this.titleCategory = "すべての製品";
          } else if (value === "HO") {
            this.titleNHO = "HOゲージ";
            this.titleCategory = "すべての製品";
          } else {
            this.titleNHO = "N/HOゲージ";
            this.titleCategory = "すべての製品（N/HO）";
          }

          // フィルター用
          this.filterNHO = value;
          this.filterCategoryParent = ""; // デフォルト
          this.filterCategoryChild = ""; // デフォルト

          // パラメータを上書き・更新
          const currentURL = window.location.href;
          const url = new URL(currentURL);
          const params = new URLSearchParams(url.search);

          // クリア
          this.filterSearchWord = ""; // 検索文字フィルター用データ：デフォルト：絞り込みなし
          this.filterSearchYear = ""; // 検索年フィルター用データ：デフォルト：絞り込みなし
          this.filterSearchMonth = ""; // 検索月フィルター用データ：デフォルト：絞り込みなし
          this.filterSearchCategory = ""; // 検索カテゴリフィルター用データ：デフォルト：絞り込みなし
          this.filterSearchNHO = ""; // 検索NHOフィルター用データ：デフォルト：絞り込みなし
          this.inputAddYearValue = "";
          this.inputAddMonthValue = "";
          this.inputAddCategoryValue = "";
          this.selectCategoryValuePc = "すべての製品"; //検索窓カテゴリセレクトPC用

          this.paramQ = this.filterSearchWord;
          this.paramYear = this.filterSearchYear;
          this.paramMonth = this.filterSearchMonth;

          params.set("q", this.paramQ);
          params.set("year", this.paramYear);
          params.set("month", this.paramMonth);

          // パラメータ更新
          this.paramCategory = this.filterCategoryParent;
          this.paramCategoryChild = this.filterCategoryChild;
          this.paramNHO = this.filterNHO;
          this.paramflag = "category";
          params.set("category", this.paramCategory);
          params.set("category_child", this.paramCategoryChild);
          params.set("nho", this.paramNHO);
          params.set("flag", this.paramflag);
          url.search = params.toString();
          const newURL = url.toString();
          history.replaceState(null, null, newURL);

          // フィルター：NHO
          this.setFilter(this.isCheckedStock, this.filterNHO, this.filterCategoryParent, this.filterCategoryChild, this.searchInput, this.searchYear, this.searchMonth);
        },
        clickFilterCategoryParent(value, label) {
          event.preventDefault();

          // タイトル用
          this.titleCategory = label;
          if (value.startsWith("ho")) {
            // ho始まりの場合
            this.titleNHO = "HOゲージ";
          } else {
            this.titleNHO = "Nゲージ";
          }

          // フィルター用
          this.filterNHO = ""; // デフォルト
          this.filterCategoryParent = value;
          this.filterCategoryChild = ""; // デフォルト

          // パラメータを上書き・更新
          const currentURL = window.location.href;
          const url = new URL(currentURL);
          const params = new URLSearchParams(url.search);

          // クリア
          this.filterSearchWord = ""; // 検索文字フィルター用データ：デフォルト：絞り込みなし
          this.filterSearchYear = ""; // 検索年フィルター用データ：デフォルト：絞り込みなし
          this.filterSearchMonth = ""; // 検索月フィルター用データ：デフォルト：絞り込みなし
          this.filterSearchCategory = ""; // 検索カテゴリフィルター用データ：デフォルト：絞り込みなし
          this.filterSearchNHO = ""; // 検索NHOフィルター用データ：デフォルト：絞り込みなし
          this.inputAddYearValue = "";
          this.inputAddMonthValue = "";
          this.inputAddCategoryValue = "";
          this.selectCategoryValuePc = "すべての製品"; //検索窓カテゴリセレクトPC用

          this.paramQ = this.filterSearchWord;
          this.paramYear = this.filterSearchYear;
          this.paramMonth = this.filterSearchMonth;

          params.set("q", this.paramQ);
          params.set("year", this.paramYear);
          params.set("month", this.paramMonth);

          // パラメータ更新
          this.paramCategory = this.filterCategoryParent;
          this.paramCategoryChild = this.filterCategoryChild;
          this.paramNHO = this.filterNHO;
          this.paramflag = "category";
          params.set("category", this.paramCategory);
          params.set("category_child", this.paramCategoryChild);
          params.set("nho", this.paramNHO);
          params.set("flag", this.paramflag);
          url.search = params.toString();
          const newURL = url.toString();
          history.replaceState(null, null, newURL);

          // フィルター：大カテゴリー
          this.setFilter(this.isCheckedStock, this.filterNHO, this.filterCategoryParent, this.filterCategoryChild, this.searchInput, this.searchYear, this.searchMonth);
        },
        clickFilterCategoryChild(value, label) {
          event.preventDefault();

          // タイトル用
          this.titleCategory = label;
          if (value.startsWith("ho")) {
            // ho始まりの場合
            this.titleNHO = "HOゲージ";
          } else {
            this.titleNHO = "Nゲージ";
          }

          // フィルター用
          this.filterNHO = ""; // デフォルト
          this.filterCategoryParent = ""; // デフォルト
          this.filterCategoryChild = value;

          // パラメータを上書き・更新
          const currentURL = window.location.href;
          const url = new URL(currentURL);
          const params = new URLSearchParams(url.search);

          // クリア
          this.filterSearchWord = ""; // 検索文字フィルター用データ：デフォルト：絞り込みなし
          this.filterSearchYear = ""; // 検索年フィルター用データ：デフォルト：絞り込みなし
          this.filterSearchMonth = ""; // 検索月フィルター用データ：デフォルト：絞り込みなし
          this.filterSearchCategory = ""; // 検索カテゴリフィルター用データ：デフォルト：絞り込みなし
          this.filterSearchNHO = ""; // 検索NHOフィルター用データ：デフォルト：絞り込みなし
          this.inputAddYearValue = "";
          this.inputAddMonthValue = "";
          this.inputAddCategoryValue = "";
          this.selectCategoryValuePc = "すべての製品"; //検索窓カテゴリセレクトPC用

          this.paramQ = this.filterSearchWord;
          this.paramYear = this.filterSearchYear;
          this.paramMonth = this.filterSearchMonth;

          params.set("q", this.paramQ);
          params.set("year", this.paramYear);
          params.set("month", this.paramMonth);

          // パラメータ更新
          this.paramCategory = this.filterCategoryParent;
          this.paramCategoryChild = this.filterCategoryChild;
          this.paramNHO = this.filterNHO;
          this.paramflag = "category";
          params.set("category", this.paramCategory);
          params.set("category_child", this.paramCategoryChild);
          params.set("nho", this.paramNHO);
          params.set("flag", this.paramflag);
          url.search = params.toString();
          const newURL = url.toString();
          history.replaceState(null, null, newURL);

          // フィルター：小カテゴリー
          this.setFilter(this.isCheckedStock, this.filterNHO, this.filterCategoryParent, this.filterCategoryChild, this.searchInput, this.searchYear, this.searchMonth);
        },
        inputAddYear(value) {
          // 検索窓のデータ送信用に格納
          this.inputAddYearValue = value;
        },
        inputAddMonth(value) {
          // 検索窓のデータ送信用に格納
          this.inputAddMonthValue = value;
        },
        inputAddCategory(value) {
          // 検索窓のデータ送信用に格納
          this.inputAddCategoryValue = value;
        },
        clickFilterSearch() {
          // 半角英数字、全角カタカナ変換
          let word_conv_hankaku = convertToHalfWidth(this.filterSearchWord);
          let word_katakana = kanaHalfToFull(word_conv_hankaku);

          // フィルター
          this.filterSearchWord = word_katakana; // フィルター：検索ワード
          this.filterSearchYear = this.inputAddYearValue; // フィルター：年
          this.filterSearchMonth = this.inputAddMonthValue; // フィルター：検索ワード
          this.filterSearchCategory = this.inputAddCategoryValue; // フィルター：カテゴリ
          if (this.filterSearchCategory === "N" || this.filterSearchCategory === "HO") {
            this.filterSearchNHO = this.filterSearchCategory; // フィルター：NHO
            this.filterSearchCategory = ""; // フィルター：カテゴリ
          } else {
            this.filterSearchNHO = "";
          }

          // console.log("検索窓：ワード:", this.filterSearchWord);
          // console.log("検索窓：年:", this.filterSearchYear);
          // console.log("検索窓：月:", this.filterSearchMonth);
          // console.log("検索窓：カテゴリ:", this.filterSearchCategory);
          // console.log("検索窓：NHO:", this.filterSearchNHO);

          // タイトル用
          this.titleSearch = this.filterSearchWord;
          this.titleSearchYear = this.filterSearchYear;
          this.titleSearchMonth = this.filterSearchMonth;
          if (this.inputAddCategoryValue !== "") {
            if (this.inputAddCategoryValue === "HO" || this.inputAddCategoryValue.includes("ho-")) {
              this.titleSearchNHO = "HOゲージ";
            } else {
              this.titleSearchNHO = "Nゲージ";
            }
          } else {
            this.titleSearchNHO = "N/HOゲージ";
          }

          if (this.inputAddCategoryValue == "") {
            this.titleSearchCategory = "すべての製品";
          }

          if (this.inputAddCategoryValue === "cat-carset" || this.inputAddCategoryValue === "ho-cat-carset") {
            this.titleSearchCategory = "車両";
          }

          if (this.inputAddCategoryValue === "cat-cont") {
            this.titleSearchCategory = "制御機器";
          }

          if (this.inputAddCategoryValue === "cat-rail") {
            this.titleSearchCategory = "レール";
          }

          if (this.inputAddCategoryValue === "cat-struct") {
            this.titleSearchCategory = "建物";
          }

          if (this.inputAddCategoryValue === "cat-etc" || this.inputAddCategoryValue === "ho-cat-etc") {
            this.titleSearchCategory = "その他";
          }

          if (this.inputAddCategoryValue === "cat-oparts" || this.inputAddCategoryValue === "ho-cat-oparts") {
            this.titleSearchCategory = "オプショナルパーツ";
          }

          if (this.inputAddCategoryValue === "cat-parts" || this.inputAddCategoryValue === "ho-cat-parts") {
            this.titleSearchCategory = "分売パーツ";
          }

          // // サイドバー用データクリア
          // this.filterNHO = ""; // デフォルト
          // this.filterCategoryParent = ""; // デフォルト
          // this.filterCategoryChild = ""; // デフォルト

          // パラメータ更新
          // this.paramflag = "search";

          // クリア
          const currentURL = window.location.href;
          const url = new URL(currentURL);
          const params = new URLSearchParams(url.search);

          this.filterNHO = ""; // NHOフィルター用データ：デフォルト：絞り込みなし
          this.filterCategoryParent = ""; // 大カテゴリーフィルター用データ：デフォルト：絞り込みなし
          this.filterCategoryChild = ""; // 小カテゴリーフィルター用データ：デフォルト：絞り込みなし

          this.paramCategoryChild = this.filterCategoryChild;
          params.set("category_child", this.paramCategoryChild);

          // アコーディオンクリア
          this.setCategoryChild.catCarsetIsShow = false;
          this.setCategoryChild.catContIsShow = false;
          this.setCategoryChild.catRailIsShow = false;
          this.setCategoryChild.catStructIsShow = false;
          this.setCategoryChild.catEtcIsShow = false;
          this.setCategoryChild.catOpartsShow = false;
          this.setCategoryChild.catPartsShow = false;
          this.setCategoryChild.hoCatCarsetIsShow = false;
          this.setCategoryChild.hoCatEtcIsShow = false;
          this.setCategoryChild.hoCatOpartsShow = false;
          this.setCategoryChild.hoCatPartsShow = false;

          // パラメータ更新
          this.paramQ = this.filterSearchWord;
          this.paramYear = this.filterSearchYear;
          this.paramMonth = this.filterSearchMonth;
          this.paramCategory = this.filterSearchCategory;
          this.paramNHO = this.filterSearchNHO;
          this.paramflag = "search";

          params.set("q", this.paramQ);
          params.set("year", this.paramYear);
          params.set("month", this.paramMonth);
          params.set("category", this.paramCategory);
          params.set("nho", this.paramNHO);
          params.set("flag", this.paramflag);

          url.search = params.toString();
          const newURL = url.toString();
          history.replaceState(null, null, newURL);

          // アンカーリンク
          const $target = $("#result");
          const $position = $($target).offset().top;
          $("html,body").animate({ scrollTop: $position }, 500);

          // フィルター：小カテゴリー
          this.setFilter(this.isCheckedStock, this.filterSearchNHO, this.filterSearchCategory, this.filterCategoryChild, this.filterSearchWord, this.filterSearchYear, this.filterSearchMonth);
        },
        selectChangeSort(value, click) {
          // console.log("ソート発生");

          if (value) {
            this.selectSort = value;
          }

          // console.log("値", this.selectSort);

          // date_desc 発売月が新しい順 降順
          if (this.selectSort === "date_desc") {
            // console.log("発売月が新しい順");
            this.post.sort(customDateSort);
          }

          // // date_asc 発売月が古い順 昇順
          if (this.selectSort === "date_asc") {
            // console.log("発売月が古い順");
            this.post.sort(customDateSortReverse01);
          }

          // name_asc 品名順A-Z 昇順
          if (this.selectSort === "name_asc") {
            // console.log("品名順A-Z");
            this.post.sort((a, b) => a["商　品　名"].localeCompare(b["商　品　名"]));
          }
          // name_desc 品名順Z-A 降順
          if (this.selectSort === "name_desc") {
            // console.log("品名順Z-A");
            this.post.sort((a, b) => b["商　品　名"].localeCompare(a["商　品　名"]));
          }
          // num_asc 品番順A-Z 昇順
          if (this.selectSort === "hinban_asc") {
            // console.log("品番順A-Z");
            this.post.sort((a, b) => a["品番"].localeCompare(b["品番"]));
          }
          // num_desc 品番順Z-A 降順
          if (this.selectSort === "hinban_desc") {
            // console.log("品番順Z-A");
            this.post.sort((a, b) => b["品番"].localeCompare(a["品番"]));
          }

          // クリック時
          if (click) {
            // console.log("ソートのパラメータ更新");

            // フェードスタート
            this.startFade = true;

            // ページネーション初期値
            this.currentPage = 1;

            // パラメータを上書き・更新
            const currentURL = window.location.href;
            const url = new URL(currentURL);
            const params = new URLSearchParams(url.search);
            this.paramPage = this.currentPage;
            this.paramSort = this.selectSort;
            params.set("sort", this.paramSort);
            params.set("page", this.paramPage);
            url.search = params.toString();
            const newURL = url.toString();
            history.replaceState(null, null, newURL);

            // アンカーリンク
            const $target = $("#result");
            const $position = $($target).offset().top;
            $("html,body").animate({ scrollTop: $position }, 500);
          }
        },
        setFilter(stock, nho, parent, child, word, year, month) {
          // フェードスタート
          this.startFade = true;
          // フィルター開始
          let filtered = this.postJson; // 恒久JSON

          // フィルター：在庫・生産予定ありのみ表示
          // 在庫にデータがあるもののみまたは、今月に○または、来月に○または、再来月にデータがあるもののみ

          if (stock) {
            filtered = filtered.filter(
              (item) =>
                item["在庫"] !== "" ||
                item[this.productionSchedule01] === "○" ||
                item[this.productionSchedule01].includes("発売予定") ||
                item[this.productionSchedule01].includes("未定") ||
                item[this.productionSchedule02] === "○" ||
                item[this.productionSchedule02].includes("発売予定") ||
                item[this.productionSchedule02].includes("未定") ||
                item[this.productionSchedule03] !== ""
            );
          }

          // フィルター：NHO
          if (nho === "N") {
            filtered = filtered.filter((item) => item["N/HO"].includes("N") || item["N/HO"].includes(""));
          }
          if (nho === "HO") {
            filtered = filtered.filter((item) => item["N/HO"].includes("HO"));
          }

          // フィルター：大カテゴリ絞り込み
          if (parent) {
            filtered = filtered.filter((item) => item["大カテゴリ"].includes(parent));
          }

          // フィルター：小カテゴリ絞り込み
          // console.log(child);
          if (child) {
            filtered = filtered.filter((item) => item["小カテゴリ"].includes(child));
          }

          // フィルター：ワード絞り込み
          // console.log(word);
          if (word) {
            // 最後の文字が「系」もしくは「番代」という単語だったら削除
            let wordSlice = word;
            if (wordSlice.slice(-1) === "系") {
              wordSlice = wordSlice.slice(0, -1);
            } else if (wordSlice.slice(-2) === "番代") {
              wordSlice = wordSlice.slice(0, -2);
            }

            filtered = filtered.filter((item) => item["品番"].indexOf(word) > -1 || item["商　品　名"].indexOf(wordSlice.toLowerCase()) > -1 || item["商　品　名"].indexOf(wordSlice.toUpperCase()) > -1 || item["在庫"].indexOf(word) > -1 || item["JANコード"] === word);
          }

          // フィルター：年絞り込み
          if (year) {
            filtered = this.filterYear(filtered, year);
          }

          // フィルター：月絞り込み
          if (month) {
            filtered = this.filterMonth(filtered, month);
          }

          // ページネーション初期値
          this.currentPage = 1;

          // データ格納
          this.post = filtered;

          // ソート
          this.selectChangeSort();

          // パラメータ
          const currentURL = window.location.href;
          const url = new URL(currentURL);
          const params = new URLSearchParams(url.search);

          this.paramPage = this.currentPage;
          // console.log(this.currentPage);
          // console.log(this.paramPage);

          // パラメータを上書き
          // params.set("q", this.paramQ);
          // params.set("year", this.paramYear);
          // params.set("month", this.paramMonth);
          // params.set("category", this.paramCategory);
          // params.set("category_child", this.paramCategoryChild);
          // params.set("nho", this.paramNHO);
          // params.set("sort", this.paramSort);
          // params.set("srchmode", this.paramSrchmode);
          // params.set("display", this.paramDisplay);
          params.set("page", this.paramPage);
          // params.set("flag", this.paramflag);

          // 新しいパラメータを含むURLを構築
          url.search = params.toString();
          const newURL = url.toString();

          // URL遷移せずに書き換え
          history.replaceState(null, null, newURL);

          // アンカーリンク
          const $target = $("#result");
          const $position = $($target).offset().top;
          $("html,body").animate({ scrollTop: $position }, 500);
        },
        displayPages(current, last, delta = 1) {
          // 表示するページ数
          if (last === 1) return [1];

          if (current == 1 || current == last) {
            delta = 2;
          }

          const left = current - delta,
            right = current + delta + 1,
            range = [];

          // if (last > 1 && current !== 1) {
          //   range.push("<");
          // }

          for (let i = 1; i <= last; i++) {
            if (i == 1 || i == last || (i >= left && i < right)) {
              if (i === left && i > 2) {
                range.push("...");
              }

              range.push(i);

              if (i === right - 1 && i < last - 1) {
                range.push("...");
              }
            }
          }

          // if (last > 1 && current !== last) {
          //   range.push(">");
          // }

          return range;
        },
        changePage(pageNumber) {
          // ページネーションクリック
          event.preventDefault();

          // console.log("ページネーションクリック");

          // ページ更新
          this.currentPage = pageNumber;

          // パラメータを上書き・更新
          const currentURL = window.location.href;
          const url = new URL(currentURL);
          const params = new URLSearchParams(url.search);
          this.paramPage = this.currentPage;
          params.set("page", this.paramPage);
          url.search = params.toString();
          const newURL = url.toString();
          history.replaceState(null, null, newURL);

          // アンカーリンク
          const $target = $("#result");
          const $position = $($target).offset().top;
          $("html,body").animate({ scrollTop: $position }, 500);
        },
      },
      created() {
        this.getPosts();
      },
      updated() {
        // DOM ツリーを更新した後に呼び出し
        if ($(".p-products-table-list-sp__tops").length) {
          $(window).on("scroll", function () {
            const headerHight = 61;
            const $listTops = $(".p-products-table-list-sp__tops");
            const $list = $(".p-products-table-list-sp");
            const $listLast = $(".p-products-table-list-sp__bottoms:last-child");
            const listTopsTop = $list.offset().top - headerHight;
            const listBottom = $listLast.offset().top - headerHight - $listTops.height();
            let listBottomHeight = $list.height() - $listLast.height();

            if (listBottomHeight < 0) {
              listBottomHeight = 0;
            }

            if ($(window).scrollTop() > listTopsTop) {
              $listTops.css({ position: "fixed", top: headerHight + "px" });
              if ($(window).scrollTop() > listBottom) {
                $listTops.css({ position: "absolute", top: listBottomHeight + "px" });
              }
            } else {
              $listTops.css({ position: "absolute", top: "0" });
            }
          });
        }

        lazyload();
        if (this.startFade) {
          $(".js-faded").fadeOut(0).fadeIn(300);
          this.startFade = false;
        }
      },
      computed: {
        paginatedData() {
          // ページネーション用にJSONデータ修正
          const startIndex = (this.currentPage - 1) * this.itemsPerPage;
          const endIndex = startIndex + this.itemsPerPage;
          return this.post.slice(startIndex, endIndex);
        },
        totalPages() {
          // 総ページ数計算
          return Math.ceil(this.post.length / this.itemsPerPage);
        },
      },
    });
  });

  // ==========================================================================
  // 全角英数字を半角英数字に変換
  // ==========================================================================
  function convertToHalfWidth(str) {
    return str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function (s) {
      return String.fromCharCode(s.charCodeAt(0) - 0xfee0);
    });
  }

  // ==========================================================================
  // 半角カタカナを全角カタカナに変換
  // ==========================================================================
  function convertToFullWidthKatakana(str) {
    return str.replace(/[ｦ-ﾟ]/g, function (s) {
      return String.fromCharCode(s.charCodeAt(0) + 0xfee0);
    });
  }

  function kanaHalfToFull(str) {
    var kanaMap = {
      ｶﾞ: "ガ",
      ｷﾞ: "ギ",
      ｸﾞ: "グ",
      ｹﾞ: "ゲ",
      ｺﾞ: "ゴ",
      ｻﾞ: "ザ",
      ｼﾞ: "ジ",
      ｽﾞ: "ズ",
      ｾﾞ: "ゼ",
      ｿﾞ: "ゾ",
      ﾀﾞ: "ダ",
      ﾁﾞ: "ヂ",
      ﾂﾞ: "ヅ",
      ﾃﾞ: "デ",
      ﾄﾞ: "ド",
      ﾊﾞ: "バ",
      ﾋﾞ: "ビ",
      ﾌﾞ: "ブ",
      ﾍﾞ: "ベ",
      ﾎﾞ: "ボ",
      ﾊﾟ: "パ",
      ﾋﾟ: "ピ",
      ﾌﾟ: "プ",
      ﾍﾟ: "ペ",
      ﾎﾟ: "ポ",
      ｳﾞ: "ヴ",
      ﾜﾞ: "ヷ",
      ｦﾞ: "ヺ",
      ｱ: "ア",
      ｲ: "イ",
      ｳ: "ウ",
      ｴ: "エ",
      ｵ: "オ",
      ｶ: "カ",
      ｷ: "キ",
      ｸ: "ク",
      ｹ: "ケ",
      ｺ: "コ",
      ｻ: "サ",
      ｼ: "シ",
      ｽ: "ス",
      ｾ: "セ",
      ｿ: "ソ",
      ﾀ: "タ",
      ﾁ: "チ",
      ﾂ: "ツ",
      ﾃ: "テ",
      ﾄ: "ト",
      ﾅ: "ナ",
      ﾆ: "ニ",
      ﾇ: "ヌ",
      ﾈ: "ネ",
      ﾉ: "ノ",
      ﾊ: "ハ",
      ﾋ: "ヒ",
      ﾌ: "フ",
      ﾍ: "ヘ",
      ﾎ: "ホ",
      ﾏ: "マ",
      ﾐ: "ミ",
      ﾑ: "ム",
      ﾒ: "メ",
      ﾓ: "モ",
      ﾔ: "ヤ",
      ﾕ: "ユ",
      ﾖ: "ヨ",
      ﾗ: "ラ",
      ﾘ: "リ",
      ﾙ: "ル",
      ﾚ: "レ",
      ﾛ: "ロ",
      ﾜ: "ワ",
      ｦ: "ヲ",
      ﾝ: "ン",
      ｧ: "ァ",
      ｨ: "ィ",
      ｩ: "ゥ",
      ｪ: "ェ",
      ｫ: "ォ",
      ｯ: "ッ",
      ｬ: "ャ",
      ｭ: "ュ",
      ｮ: "ョ",
      "｡": "。",
      "､": "、",
      ｰ: "ー",
      "｢": "「",
      "｣": "」",
      "･": "・",
    };

    var reg = new RegExp("(" + Object.keys(kanaMap).join("|") + ")", "g");
    return str
      .replace(reg, function (match) {
        return kanaMap[match];
      })
      .replace(/ﾞ/g, "゛")
      .replace(/ﾟ/g, "゜");
  }

  // ==========================================================================
  // ソート
  // ==========================================================================

  // 製品検索用
  // 降順：日付の新しい順
  // ▼ 想定ソート結果
  // ・2023年10月10日発売
  // ・2023年10月5日発売
  // ・2023年10月発売
  // ・2023年9月10日発売
  // ・2023年9月5日発売
  // ・2023年9月発売
  // ・未定
  // ・発売月なし（空白）
  function customDateSort(a, b) {
    // "未定"を後ろに配置
    if (a["発売月"] === "" && b["発売月"] !== "") {
      return 1;
    }
    if (b["発売月"] === "" && a["発売月"] !== "") {
      return -1;
    }

    // "未定"を後ろに配置
    if (a["発売月"] === "未定" && b["発売月"] !== "未定") {
      return 1;
    }
    if (b["発売月"] === "未定" && a["発売月"] !== "未定") {
      return -1;
    }

    // 年月が同じ場合に日にちを比較してソートするカスタム比較関数
    const yearMonthA = (a["発売月"].match(/\d{4}\/\d{2}/) || "") + "";
    const yearMonthB = (b["発売月"].match(/\d{4}\/\d{2}/) || "") + "";

    if (yearMonthA === yearMonthB) {
      // 年月が同じ場合、日にちがある方を優先的にソート
      if (hasDate(a["発売月"]) && !hasDate(b["発売月"])) {
        return -1;
      } else if (!hasDate(a["発売月"]) && hasDate(b["発売月"])) {
        return 1;
      } else {
        // 日にちが同じ場合は文字列の比較
        return b["発売月"].localeCompare(a["発売月"]);
      }
    }

    return yearMonthB.localeCompare(yearMonthA);
  }

  // 製品検索用
  // 昇順：日付の古い順
  // ▼ 想定ソート結果
  //  ・2023年9月5日発売
  // ・2023年9月10日発売
  // ・2023年9月発売
  // ・2023年10月5日発売
  // ・2023年10月10日発売
  // ・2023年10月発売
  // ・未定
  // ・発売月なし（空白）
  function customDateSortReverse01(a, b) {
    // ""を後ろに配置
    if (a["発売月"] === "" && b["発売月"] !== "") {
      return 1;
    }
    if (b["発売月"] === "" && a["発売月"] !== "") {
      return -1;
    }

    // "未定"を後ろに配置
    if (a["発売月"] === "未定" && b["発売月"] !== "未定") {
      return 1;
    }
    if (b["発売月"] === "未定" && a["発売月"] !== "未定") {
      return -1;
    }

    // 年月が同じ場合に日にちを比較してソートするカスタム比較関数
    const yearMonthA = (a["発売月"].match(/\d{4}\/\d{2}/) || "") + "";
    const yearMonthB = (b["発売月"].match(/\d{4}\/\d{2}/) || "") + "";

    if (yearMonthA === yearMonthB) {
      // 年月が同じ場合、日にちがある方を優先的にソート
      if (hasDate(a["発売月"]) && !hasDate(b["発売月"])) {
        return -1;
      } else if (!hasDate(a["発売月"]) && hasDate(b["発売月"])) {
        return 1;
      } else {
        // 日にちが同じ場合は文字列の比較
        return a["発売月"].localeCompare(b["発売月"]);
      }
    }

    return yearMonthA.localeCompare(yearMonthB);
  }

  // 昇順：日付の古い順
  // ▼ 想定ソート結果
  //  ・2023年9月5日発売
  // ・2023年9月10日発売
  // ・2023年9月発売
  // ・2023年10月5日発売
  // ・2023年10月10日発売
  // ・2023年10月発売
  // ・未定
  // ・発売月なし（空白）
  function customDateSortReverse(a, b) {
    // ""を後ろに配置
    if (a["発売スケジュールソート用データ"] === "" && b["発売スケジュールソート用データ"] !== "") {
      return 1;
    }
    if (b["発売スケジュールソート用データ"] === "" && a["発売スケジュールソート用データ"] !== "") {
      return -1;
    }

    // "未定"を後ろに配置
    if (a["発売スケジュールソート用データ"] === "未定" && b["発売スケジュールソート用データ"] !== "未定") {
      return 1;
    }
    if (b["発売スケジュールソート用データ"] === "未定" && a["発売スケジュールソート用データ"] !== "未定") {
      return -1;
    }

    // 年月が同じ場合に日にちを比較してソートするカスタム比較関数
    const yearMonthA = (a["発売スケジュールソート用データ"].match(/\d{4}\/\d{2}/) || "") + "";
    const yearMonthB = (b["発売スケジュールソート用データ"].match(/\d{4}\/\d{2}/) || "") + "";

    if (yearMonthA === yearMonthB) {
      // 年月が同じ場合、日にちがある方を優先的にソート
      if (hasDate(a["発売スケジュールソート用データ"]) && !hasDate(b["発売スケジュールソート用データ"])) {
        return -1;
      } else if (!hasDate(a["発売スケジュールソート用データ"]) && hasDate(b["発売スケジュールソート用データ"])) {
        return 1;
      } else {
        // 日にちが同じ場合は文字列の比較
        return a["発売スケジュールソート用データ"].localeCompare(b["発売スケジュールソート用データ"]);
      }
    }

    return yearMonthA.localeCompare(yearMonthB);
  }

  // 年月と日付があるかどうかを判定する関数
  function hasDate(str) {
    return /\d{4}\/\d{2}\/\d{2}/.test(str);
  }

  // END
})();

// ==========================================================================
// 製品詳細ページボタン（検索維持用）
// ==========================================================================
// カテゴリラベル
function productsCategoryTagFunction(event, category) {
  event.preventDefault();
  if (category.includes("cat-")) {
    url = event.target.getAttribute("href") + "?category=" + category;
  } else {
    url = event.target.getAttribute("href") + "?category_child=" + category;
  }
  window.location.href = url;
}
